/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

// ran this thru claudes code refactoring tool

// redesign this component to look more elegant and polished
// Use Tailwind CSS className only. Preserve all logic, Redux hooks, and routing exactly as-is.
// use tailwind css in the className directive 
// ask me a series of questions to gather additional context you need to best achive this task
// "Colors come from dynamic seller props — use hex + opacity string concatenation (e.g. sellerPrimaryColor1 + '20') for tints, never hardcode colors."
// Give me the complete code with instructions

//ran this thru claudes design


// add fuctionallty to reset the price range on the indivduls filter
// and all filters on the indivdual and all filter buttons 
// if isVisible('isVisibleSitePayments') is true
// keep everything else the same, just add the functionality to reset the price range 
// give me the complete code to copy with instructions


// replace all hard coded opacities with these sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, 
// and make primaryColor and secondaryColor availbele to all sub-components
// give me the entire code to copy

// make all content and the full page width below ShopBanner set background color to sellerComponentBackgroundColor
// if there is not to much new code, just give me the relevant code

// show Fleishig / Meat / Parve if sellerBoolShowKosher is true
// give me the relevant code to copy with instructions


import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { Range } from 'react-range';
import { AiFillStar } from 'react-icons/ai';
import { CiStar } from 'react-icons/ci';
import { BsFillGridFill } from 'react-icons/bs';
import { FaThList, FaCaretDown, FaCaretUp, FaGift } from 'react-icons/fa';
import { MdOutlineRestaurantMenu, MdFilterListOff } from 'react-icons/md';
import { IoFilterSharp, IoClose } from 'react-icons/io5';
import { HiChevronUp } from 'react-icons/hi2';
import Collapsible from 'react-collapsible';

import { price_range_product, query_products } from '../store/reducers/homeReducer';

import Products from '../components/products/Products';
import ShopProductGridListView from '../components/products/ShopProductGridListView';
import Pagination from '../components/Pagination';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ShopBanner from '../components/ShopBanner';
import GetSellerConfig from '../components/GetSellerConfig';

import config from '../config';

// ---------------------------------------------------------------------------
// Custom hook – unchanged
// ---------------------------------------------------------------------------
function useShopFilters(sellerFrontEndURL, priceRange, sortPrice, pageNumber) {
    const dispatch = useDispatch();
    const intPriceRangeStep = config.INT_FRONTEND_PRICE_RANGE_STEP;

    const [priceState, setPriceState] = useState({ values: [priceRange.low, priceRange.high] });

    useEffect(() => {
        setPriceState(prev => ({
            values: [
                Math.min(Math.max(prev.values[0], priceRange.low), priceRange.high),
                Math.min(Math.max(prev.values[1], priceRange.low), priceRange.high),
            ]
        }));
    }, [priceRange]);

    const [filters, setFilters] = useState({
        category: '', mainIngredient: '', FMP: '', cookingMethod: '',
        byThePan: '', dietaryRestrictions: '', cuisineType: '', holiday: '', rating: '',
    });

    const setFilter = (key, value) => setFilters(prev => ({ ...prev, [key]: value }));

    const makeQueryAction = (overrides = {}) =>
        query_products({
            webSiteOrigin: sellerFrontEndURL,
            low: priceState.values[0],
            high: priceState.values[1],
            sortPrice, pageNumber,
            ...filters, ...overrides,
        });

    useEffect(() => {
        dispatch(makeQueryAction());
    }, [
        sellerFrontEndURL,
        priceState.values[0], priceState.values[1],
        filters.category, filters.mainIngredient, filters.FMP,
        filters.cookingMethod, filters.byThePan, filters.dietaryRestrictions,
        filters.cuisineType, filters.holiday, filters.rating,
        sortPrice, pageNumber,
    ]);

    const resetAllFilters = () => {
        const cleared = {
            category: '', mainIngredient: '', FMP: '', cookingMethod: '',
            byThePan: '', dietaryRestrictions: '', cuisineType: '', holiday: '', rating: '',
        };
        setFilters(cleared);
        setPriceState({ values: [priceRange.low, priceRange.high] });
        dispatch(query_products({ webSiteOrigin: sellerFrontEndURL, low: priceRange.low, high: priceRange.high, sortPrice, pageNumber, ...cleared }));
        dispatch(price_range_product(sellerFrontEndURL));
    };

    const resetSingleFilter = (key) => {
        setFilter(key, '');
        dispatch(makeQueryAction({ [key]: '' }));
    };

    const resetPriceRange = () => {
        setPriceState({ values: [priceRange.low, priceRange.high] });
        dispatch(price_range_product(sellerFrontEndURL));
    };

    const queryFilter = (key, value, checked) => setFilter(key, checked ? value : '');

    return {
        filters, priceState, setPriceState, intPriceRangeStep,
        resetAllFilters, resetSingleFilter, resetPriceRange, queryFilter,
    };
}

// ---------------------------------------------------------------------------
// FilterSection
// ---------------------------------------------------------------------------
function FilterSection({
    title,
    primaryColor, secondaryColor,
    colorSuffixDark, colorSuffixMedium, colorSuffixLight,
    open = false, onClearThis, onClearAll, children
}) {
    const triggerBase = (isOpen) => (
        <div
            className="trigger-wrapper flex items-center justify-between w-full px-2.5 py-2 transition-colors cursor-pointer"
            style={{ color: primaryColor, backgroundColor: primaryColor + colorSuffixLight }}>
            <span className="font-semibold text-[13px] tracking-wide ml-2 mt-0.5 mb-0.5">{title}</span>
            <span
                className="font-bold mr-1"
                style={{
                    display: 'inline-flex',
                    transform: isOpen ? 'rotate(0deg)' : 'rotate(180deg)',
                    transition: 'transform 0.4s ease',
                }}>
                <HiChevronUp size={18} />
            </span>
        </div>
    );

    return (
        <div className='bg-white rounded-md'>
            <div
                className="border rounded-md mb-2 overflow-hidden border-black"
                style={{  borderColor: primaryColor + colorSuffixDark }}>
                <Collapsible
                    trigger={triggerBase(false)}
                    triggerWhenOpen={triggerBase(true)}
                    transitionTime={250}
                    easing="ease-in-out"
                    contentOuterClassName="overflow-hidden"
                    open={open}>
                    <div className='bg-white'>
                        <div style={{ backgroundColor: primaryColor + colorSuffixLight }}>
                            <div className="px-2 pt-1.5 pb-0.5">
                                {children}
                            </div>
                        </div>
                    </div>
                    <div className='bg-white'>
                        <div
                            className="flex gap-1.5 px-2 py-1.5"
                            style={{ 
                                borderTop: `2px solid ${primaryColor + colorSuffixLight}`, 
                                backgroundColor: primaryColor + colorSuffixLight 
                            }}>
                            <button
                                onClick={onClearThis}
                                className="flex-1 flex items-center justify-center gap-1 py-1 rounded-md text-[11px] 
                                font-medium border hover:font-bold text-white transition-opacity hover:opacity-90"
                                style={{ backgroundColor: primaryColor + colorSuffixDark, borderColor: primaryColor + colorSuffixDark }}>
                                <MdFilterListOff size={16} /> Clear This Filter
                            </button>
                            <button
                                onClick={onClearAll}
                                className="flex-1 flex items-center justify-center gap-1 py-1 rounded-md text-[11px] 
                                font-medium border hover:font-bold transition-opacity hover:opacity-80"
                                style={{
                                    color: primaryColor + colorSuffixDark,
                                    borderColor: primaryColor + colorSuffixDark,
                                    backgroundColor: 'white',
                                }}>
                                <MdFilterListOff size={16} /> Clear All Filters
                            </button>
                        </div>
                    </div>
                </Collapsible>
            </div>
        </div>
    );
}

// ---------------------------------------------------------------------------
// CheckboxList
// ---------------------------------------------------------------------------
function CheckboxList({
    items, activeValue, filterItemTextSize,
    primaryColor, secondaryColor,
    colorSuffixDark, colorSuffixMedium, colorSuffixLight,
    onChange
}) {
    return (
        <div className='bg-white'>
            <div
                className="grid grid-cols-2 gap-0.5 pt-1.5 border-t-2"
                style={{ backgroundColor: primaryColor + colorSuffixLight, borderColor: primaryColor + colorSuffixMedium }}>
                {items.sort().map((value) => (
                    <label
                        key={value}
                        className="flex items-center gap-1.5 px-1.5 py-1.5 rounded-md cursor-pointer transition-colors hover:bg-black/20 border"
                        style={{
                            backgroundColor: activeValue === value ? primaryColor + colorSuffixLight : undefined,
                            borderColor: activeValue === value ? primaryColor + colorSuffixDark : 'transparent',
                        }}>
                        <input
                            type="checkbox"
                            id={value}
                            style={{ accentColor: primaryColor + colorSuffixDark }}
                            checked={activeValue === value}
                            onChange={(e) => onChange(value, e.target.checked)}
                            className="shrink-0"
                        />
                        <span
                            className="break-words leading-tight"
                            style={{ color: primaryColor + colorSuffixDark, fontSize: filterItemTextSize || '12px' }}>
                            {value}
                        </span>
                    </label>
                ))}
            </div>
        </div>
    );
}

// ---------------------------------------------------------------------------
// ActiveFilterChips
// ---------------------------------------------------------------------------
function ActiveFilterChips({ filters, sellerMainIngredientTerm, primaryColor, colorSuffixDark, onRemove }) {
    const labelMap = {
        category: 'Category',
        mainIngredient: sellerMainIngredientTerm || 'Ingredient',
        FMP: 'FMP',
        cookingMethod: 'Cooking',
        byThePan: 'By Pan',
        dietaryRestrictions: 'Dietary',
        cuisineType: 'Cuisine',
        holiday: 'Holiday',
        rating: 'Rating',
    };

    const active = Object.entries(filters).filter(([, v]) => v !== '');
    if (!active.length) return null;

    return (
        <div className="flex flex-wrap gap-1.5">
            {active.map(([key, value]) => (
                <span
                    key={key}
                    className="inline-flex items-center gap-1 pl-2.5 pr-1 py-0.5 rounded-full text-[11px] font-medium text-white"
                    style={{ backgroundColor: primaryColor + colorSuffixDark }}>
                    {labelMap[key]}: {key === 'rating' ? `${value}★` : value}
                    <button
                        onClick={() => onRemove(key)}
                        className="rounded-full p-0.5 hover:bg-white/25 transition-colors"
                        aria-label={`Remove ${labelMap[key]}`}>
                        <IoClose size={11} />
                    </button>
                </span>
            ))}
        </div>
    );
}

// ---------------------------------------------------------------------------
// Main component
// ---------------------------------------------------------------------------
const Shops = () => {
    const sellerFrontEndURL = config.STR_FRONTEND_URL;
    const filterItemTextSize = '12px';

    const { categorys, allSiteProducts, products, priceRange, latest_product, totalProduct, parPage } =
        useSelector(state => state.home);
    const { seller } = useSelector(state => state.seller);
    const { userInfo } = useSelector(state => state.auth);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { holidayURLParam } = useParams();

    const { sellerComponentBackgroundColor, sellerBoolShowKosher } = GetSellerConfig();

    const primaryColor   = seller?.frontEndPrimaryColor1;
    const secondaryColor = seller?.frontEndSecondaryColor1;

    const sellerArrHexOpacityColorSuffixes = seller?.hexOpacityColorSuffixes?.split(';') || [];
    const colorSuffixDark   = sellerArrHexOpacityColorSuffixes[0] || 'FF';
    const colorSuffixMedium = sellerArrHexOpacityColorSuffixes[1] || '80';
    const colorSuffixLight  = sellerArrHexOpacityColorSuffixes[2] || '1A';

    const sellerMainIngredientTerm       = seller?.mainIngredientTerm;
    const sellerMainIngredientPluralTerm = seller?.mainIngredientPluralTerm;
    const sellerProductTerm              = seller?.productTerm;
    const sellerProductPluralTerm        = seller?.productPluralTerm;
    const isVisible = (flag) => seller?.[flag] === 'Show';

    const [showFilterPanel, setShowFilterPanel] = useState(true);
    const [styles, setStyles]                   = useState('grid');
    const [pageNumber, setPageNumber]           = useState(1);
    const [sortPrice, setSortPrice]             = useState('');

    const {
        filters, priceState, setPriceState, intPriceRangeStep,
        resetAllFilters, resetSingleFilter, resetPriceRange, queryFilter,
    } = useShopFilters(sellerFrontEndURL, priceRange, sortPrice, pageNumber);

    useEffect(() => {
        if (holidayURLParam) queryFilter('holiday', holidayURLParam, true);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        dispatch(price_range_product(sellerFrontEndURL));
    }, [sellerFrontEndURL]); // eslint-disable-line react-hooks/exhaustive-deps

    const filterOptions = useMemo(() => {
        const unique = (key, exclude) =>
            [...new Set(allSiteProducts.map(p => p[key]).filter(v => v && v !== exclude))];
        return {
            categories:           unique('category'),
            mainIngredients:      unique('mainIngredient'),
            FMPs:                 unique('FMP'),
            cookingMethods:       unique('cookingMethod'),
            byThePans:            unique('byThePan', 'NoPan'),
            dietaryRestrictions:  unique('dietaryRestrictions', 'None'),
            cuisineTypes:         unique('cuisineType'),
            holidays:             unique('holiday', 'None'),
        };
    }, [allSiteProducts]);

    const goTo = (authPath, guestPath = '/login') =>
        navigate(userInfo ? authPath : guestPath);

    const activeFilterCount = Object.values(filters).filter(v => v !== '').length;

    // All color props bundled once and spread into every FilterSection / CheckboxList
    const colorProps = { primaryColor, secondaryColor, colorSuffixDark, colorSuffixMedium, colorSuffixLight };

    const sharedFilterProps = {
        ...colorProps,
        onClearAll: resetAllFilters,
    };

    const checkboxProps = (key) => ({
        ...colorProps,
        activeValue: filters[key],
        filterItemTextSize,
        onChange: (value, checked) => queryFilter(key, value, checked),
    });

    return (
        <div>
            <style>{`
                .Collapsible__contentInner { background-color: ${secondaryColor}; }
                .Collapsible__contentOuter { cursor: default; }
                .trigger-wrapper { padding: 0; }
            `}</style>

            <Header />
            <section className="">
                <div className="">
                    <div>
                        <ShopBanner
                            homePage="Home" homeLink="/"
                            currentPageTop={`All ${sellerProductPluralTerm}`} currentPageTopLink=""
                            currentPageBottom1={`All ${sellerProductPluralTerm}`} currentPageBottomLink1=""
                            currentPageBottom2="" currentPageBottomLink2=""
                        />
                    </div>
                    <div style={{ backgroundColor: sellerComponentBackgroundColor }}>   {/* ← full width bg */}
                        <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full pt-4 mx-auto">
                            {/* Mobile filter toggle */}
                            <div className={`md:block hidden ${showFilterPanel ? 'mb-0' : 'mb-6'}`}>
                                <button
                                    onClick={() => setShowFilterPanel(!showFilterPanel)}
                                    className="flex items-center justify-center gap-1.5 w-full py-2.5 px-3 rounded-lg text-white font-medium shadow-sm transition-opacity hover:opacity-90"
                                    style={{ backgroundColor: primaryColor + colorSuffixDark }}>
                                    <IoFilterSharp size={15} />
                                    Filter {sellerProductPluralTerm}
                                    {activeFilterCount > 0 && (
                                        <span className="bg-white/25 text-white text-[11px] font-bold px-1.5 py-0.5 rounded-full leading-none">
                                            {activeFilterCount}
                                        </span>
                                    )}
                                    {showFilterPanel ? <FaCaretDown className="text-lg ml-0.5" /> : <FaCaretUp className="text-lg ml-0.5" />}
                                </button>
                            </div>

                            <div className="w-full border-none flex flex-wrap">
                                {/* ── Sidebar ── */}
                                <div className={`border-none w-3/12 md-lg:w-4/12 md:w-full pr-8
                                    ${showFilterPanel ? 'md:h-0 md:overflow-hidden md:mb-6' : 'md:h-auto md:overflow-auto md:mb-0'}`}>

                                    <div
                                        className={`${showFilterPanel ? 'flex' : 'hidden'} items-center gap-1.5 text-lg font-bold mb-3`}
                                        style={{ color: primaryColor + colorSuffixDark }}>
                                        <IoFilterSharp size={22} />
                                        Filter {sellerProductPluralTerm}
                                        {activeFilterCount > 0 && (
                                            <span
                                                className="text-[11px] font-bold text-white px-1.5 py-0.5 rounded-full leading-none"
                                                style={{ backgroundColor: primaryColor + colorSuffixDark }}>
                                                {activeFilterCount}
                                            </span>
                                        )}
                                    </div>

                                    <FilterSection title="Categories" {...sharedFilterProps} onClearThis={() => resetSingleFilter('category')}>
                                        <CheckboxList items={filterOptions.categories} {...checkboxProps('category')} />
                                    </FilterSection>

                                    <FilterSection title={sellerMainIngredientPluralTerm} {...sharedFilterProps} onClearThis={() => resetSingleFilter('mainIngredient')}>
                                        <CheckboxList items={filterOptions.mainIngredients} {...checkboxProps('mainIngredient')} />
                                    </FilterSection>

                                    {sellerBoolShowKosher && (
                                        <FilterSection title="Fleishig / Meat / Parve" {...sharedFilterProps} onClearThis={() => resetSingleFilter('FMP')}>
                                            <CheckboxList items={filterOptions.FMPs} {...checkboxProps('FMP')} />
                                        </FilterSection>
                                    )}
                                    
                                    {
                                    // <FilterSection title="Fleishig / Meat / Parve" {...sharedFilterProps} onClearThis={() => resetSingleFilter('FMP')}>
                                    //     <CheckboxList items={filterOptions.FMPs} {...checkboxProps('FMP')} />
                                    // </FilterSection>
                                    }
                                    
                                    {isVisible('isVisibleSiteCookingMethods') && (
                                        <FilterSection title="Cooking Method" {...sharedFilterProps} onClearThis={() => resetSingleFilter('cookingMethod')}>
                                            <CheckboxList items={filterOptions.cookingMethods} {...checkboxProps('cookingMethod')} />
                                        </FilterSection>
                                    )}

                                    {filterOptions.byThePans.length > 0 && (
                                        <FilterSection title="By The Pan" {...sharedFilterProps} onClearThis={() => resetSingleFilter('byThePan')}>
                                            <CheckboxList items={filterOptions.byThePans} {...checkboxProps('byThePan')} />
                                        </FilterSection>
                                    )}

                                    {filterOptions.dietaryRestrictions.length > 0 && (
                                        <FilterSection title="Dietary Restrictions" {...sharedFilterProps} onClearThis={() => resetSingleFilter('dietaryRestrictions')}>
                                            <CheckboxList items={filterOptions.dietaryRestrictions} {...checkboxProps('dietaryRestrictions')} />
                                        </FilterSection>
                                    )}

                                    {isVisible('isVisibleSiteCuisineType') && (
                                        <FilterSection title="Cuisine Type" {...sharedFilterProps} onClearThis={() => resetSingleFilter('cuisineType')}>
                                            <CheckboxList items={filterOptions.cuisineTypes} {...checkboxProps('cuisineType')} />
                                        </FilterSection>
                                    )}

                                    {isVisible('isVisibleSiteHoliday') && (
                                        <FilterSection
                                            title="Holidays"
                                            {...sharedFilterProps}
                                            onClearThis={() => resetSingleFilter('holiday')}
                                            open={!!holidayURLParam}>
                                            <CheckboxList items={filterOptions.holidays} {...checkboxProps('holiday')} />
                                        </FilterSection>
                                    )}

                                    {isVisible('isVisibleSitePayments') && (
                                        <FilterSection title="Price Range" {...sharedFilterProps} onClearThis={resetPriceRange}>
                                            <div className="p-2 flex flex-col gap-2">
                                                <Range
                                                    step={intPriceRangeStep}
                                                    min={priceRange.low}
                                                    max={priceRange.high}
                                                    values={[
                                                        Math.min(Math.max(priceState.values[0], priceRange.low), priceRange.high),
                                                        Math.min(Math.max(priceState.values[1], priceRange.low), priceRange.high),
                                                    ]}
                                                    onChange={(values) => setPriceState({ values })}
                                                    renderTrack={({ props, children }) => (
                                                        <div {...props} className="w-full h-[5px] bg-slate-200 rounded-full cursor-pointer">
                                                            {children}
                                                        </div>
                                                    )}
                                                    renderThumb={({ props }) => (
                                                        <div
                                                            className="w-[14px] h-[14px] rounded-full border-2 border-white shadow"
                                                            style={{ backgroundColor: primaryColor + colorSuffixDark }}
                                                            {...props}
                                                        />
                                                    )}
                                                />
                                                <span className="font-semibold text-base" style={{ color: primaryColor + colorSuffixDark }}>
                                                    ${Math.floor(priceState.values[0])} – ${Math.floor(priceState.values[1])}
                                                </span>
                                            </div>
                                        </FilterSection>
                                    )}

                                    {isVisible('isVisibleSiteRating') && (
                                        <FilterSection title="Rating" {...sharedFilterProps} onClearThis={() => resetSingleFilter('rating')}>
                                            <div className="py-2 flex flex-col gap-0.5">
                                                {[5, 4, 3, 2, 1].map((n) => (
                                                    <div
                                                        key={n}
                                                        onClick={() => queryFilter('rating', n, true)}
                                                        className="flex items-center gap-1 px-1.5 py-1.5 rounded-md cursor-pointer transition-colors hover:bg-black/5"
                                                        style={{
                                                            backgroundColor: filters.rating === n
                                                                ? primaryColor + colorSuffixLight
                                                                : undefined,
                                                        }}>
                                                        {Array.from({ length: 5 }, (_, i) =>
                                                            i < n
                                                                ? <AiFillStar key={i} className="text-amber-400 text-[15px]" />
                                                                : <CiStar key={i} className="text-gray-300 text-[15px]" />
                                                        )}
                                                        <span className="text-[11px] text-gray-400 ml-0.5">& up</span>
                                                    </div>
                                                ))}
                                            </div>
                                        </FilterSection>
                                    )}

                                    {/* Action buttons */}
                                    <div className="flex flex-col gap-1.5 mt-3">
                                        <div className='bg-white'>
                                            <button
                                                onClick={resetAllFilters}
                                                className="flex items-center justify-center gap-1.5 w-full py-2 px-4 rounded-lg 
                                                text-white text-[16px] font-semibold shadow-sm transition-opacity hover:opacity-85"
                                                style={{ backgroundColor: primaryColor + colorSuffixDark }}>
                                                <MdFilterListOff size={24} /> Clear All Filters
                                            </button>
                                        </div>
                                        <div className='bg-white'>
                                            <button
                                                onClick={() => goTo('/customerDashboard/sampleMenus')}
                                                className="flex items-center justify-center gap-1 w-full py-2 px-4 rounded-lg 
                                                text-[16px] font-semibold border transition-opacity hover:opacity-80"
                                                style={{
                                                    color: primaryColor + colorSuffixDark,
                                                    borderColor: primaryColor + colorSuffixMedium,
                                                    backgroundColor: primaryColor + colorSuffixLight,
                                                }}>
                                                <MdOutlineRestaurantMenu size={24} /> Sample Menus
                                            </button>
                                        </div>
                                        <div className='bg-white'>
                                            <button
                                                onClick={() => goTo('/customerDashboard/sellerPackages')}
                                                className="flex items-center justify-center gap-1.5 w-full py-2 px-4 rounded-lg 
                                                text-[16px] font-semibold border transition-opacity hover:opacity-80"
                                                style={{
                                                    color: primaryColor + colorSuffixDark,
                                                    borderColor: primaryColor + colorSuffixMedium,
                                                    backgroundColor: primaryColor + colorSuffixLight,
                                                }}>
                                                <FaGift size={18} /> Packages
                                            </button>
                                        </div>
                                    </div>

                                    {isVisible('isVisibleSiteProductsUnderFilter') && (
                                        <div
                                            className="py-3 flex gap-4 md:hidden border-2 rounded-lg mt-3 justify-center items-center"
                                            style={{ borderColor: primaryColor + colorSuffixMedium }}>
                                            <Products title={`Latest ${sellerProductPluralTerm}`} products={latest_product} parentPage="Shops" />
                                        </div>
                                    )}
                                </div>

                                {/* ── Product Grid ── */}
                                <div className="w-9/12 md-lg:w-8/12 md:w-full">
                                    <div className="pl-2 md:pl-0">

                                        {/* Toolbar */}
                                        <div className='bg-white rounded-lg'>
                                            <div
                                                className="px-3 py-1 mb-2 gap-0.5 rounded-lg border flex flex-col"
                                                style={{
                                                    borderColor: primaryColor + colorSuffixMedium,
                                                    backgroundColor: primaryColor + colorSuffixLight,
                                                }}>
                                                {/* Row 1: count + sort + toggle */}
                                                <div className="flex items-center justify-between gap-2">
                                                    <div className="text-[18px] font-medium md-lg:hidden"
                                                        style={{ color: primaryColor + colorSuffixDark }}>
                                                        {totalProduct} {sellerProductTerm}{totalProduct !== 1 ? 's' : ''}
                                                    </div>

                                                    <div className="flex items-center gap-2 ml-auto">
                                                        {isVisible('isVisibleSitePayments') && (
                                                            <select
                                                                onChange={(e) => setSortPrice(e.target.value)}
                                                                className="py-1.5 px-2.5 rounded-lg border text-sm font-medium outline-none bg-white"
                                                                style={{
                                                                    color: primaryColor + colorSuffixDark,
                                                                    borderColor: primaryColor + colorSuffixMedium,
                                                                }}>
                                                                <option value="">Sort By</option>
                                                                <option value="low-to-high">Price: Low → High</option>
                                                                <option value="high-to-low">Price: High → Low</option>
                                                            </select>
                                                        )}

                                                        {/* Grid / List toggle */}
                                                        <div
                                                            className="flex rounded-lg border overflow-hidden md-lg:hidden"
                                                            style={{ borderColor: primaryColor + colorSuffixDark }}>
                                                            <button
                                                                onClick={() => setStyles('grid')}
                                                                className="p-1.5 transition-colors"
                                                                style={{
                                                                    backgroundColor: styles === 'grid' ? primaryColor + colorSuffixLight : 'white',
                                                                    color: primaryColor + colorSuffixDark,
                                                                }}>
                                                                <BsFillGridFill size={16} />
                                                            </button>
                                                            <button
                                                                onClick={() => setStyles('list')}
                                                                className="p-1.5 transition-colors"
                                                                style={{
                                                                    backgroundColor: styles === 'list' ? primaryColor + colorSuffixLight : 'white',
                                                                    color: primaryColor + colorSuffixDark,
                                                                    borderLeft: `1px solid ${primaryColor + colorSuffixDark}`,
                                                                }}>
                                                                <FaThList size={16} />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Row 2: active filter chips */}
                                                {activeFilterCount > 0 && (
                                                    <div className="md-lg:hidden">
                                                        <ActiveFilterChips
                                                            filters={filters}
                                                            sellerMainIngredientTerm={sellerMainIngredientTerm}
                                                            primaryColor={primaryColor}
                                                            colorSuffixDark={colorSuffixDark}
                                                            onRemove={resetSingleFilter}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="pb-8">
                                            <ShopProductGridListView products={products} styles={styles} />
                                        </div>

                                        {totalProduct > parPage && (
                                            <Pagination
                                                pageNumber={pageNumber}
                                                setPageNumber={setPageNumber}
                                                totalItems={totalProduct}
                                                parPage={parPage}
                                                showItem={Math.floor(totalProduct / parPage)}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default Shops;






//claude redisgn version 1
// import React, { useEffect, useState, useMemo } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { useNavigate, useParams } from 'react-router-dom';

// import { Range } from 'react-range';
// import { AiFillStar } from 'react-icons/ai';
// import { CiStar } from 'react-icons/ci';
// import { BsFillGridFill } from 'react-icons/bs';
// import { FaThList, FaCaretDown, FaCaretUp, FaGift } from 'react-icons/fa';
// import { MdOutlineRestaurantMenu, MdFilterListOff } from 'react-icons/md';
// import { IoFilterSharp, IoClose } from 'react-icons/io5';
// import { HiChevronUp, HiChevronDown } from 'react-icons/hi2';
// import Collapsible from 'react-collapsible';

// import { price_range_product, query_products } from '../store/reducers/homeReducer';

// import Products from '../components/products/Products';
// import ShopProductGridListView from '../components/products/ShopProductGridListView';
// import Pagination from '../components/Pagination';
// import Header from '../components/Header';
// import Footer from '../components/Footer';
// import ShopBanner from '../components/ShopBanner';
// import GetSellerConfig from '../components/GetSellerConfig';

// import config from '../config';

// // ---------------------------------------------------------------------------
// // Custom hook – unchanged
// // ---------------------------------------------------------------------------
// function useShopFilters(sellerFrontEndURL, priceRange, sortPrice, pageNumber) {
//     const dispatch = useDispatch();
//     const intPriceRangeStep = config.INT_FRONTEND_PRICE_RANGE_STEP;

//     const [priceState, setPriceState] = useState({ values: [priceRange.low, priceRange.high] });
    
//     useEffect(() => {
//         setPriceState(prev => ({
//             values: [
//                 Math.min(Math.max(prev.values[0], priceRange.low), priceRange.high),
//                 Math.min(Math.max(prev.values[1], priceRange.low), priceRange.high),
//             ]
//         }));
//     }, [priceRange]);

//     const [filters, setFilters] = useState({
//         category: '', mainIngredient: '', FMP: '', cookingMethod: '',
//         byThePan: '', dietaryRestrictions: '', cuisineType: '', holiday: '', rating: '',
//     });

//     const setFilter = (key, value) => setFilters(prev => ({ ...prev, [key]: value }));

//     const makeQueryAction = (overrides = {}) =>
//         query_products({
//             webSiteOrigin: sellerFrontEndURL,
//             low: priceState.values[0],
//             high: priceState.values[1],
//             sortPrice, pageNumber,
//             ...filters, ...overrides,
//         });

//     useEffect(() => {
//         dispatch(makeQueryAction());
//     }, [
//         sellerFrontEndURL,
//         priceState.values[0], priceState.values[1],
//         filters.category, filters.mainIngredient, filters.FMP,
//         filters.cookingMethod, filters.byThePan, filters.dietaryRestrictions,
//         filters.cuisineType, filters.holiday, filters.rating,
//         sortPrice, pageNumber,
//     ]);

//     const resetAllFilters = () => {
//         const cleared = {
//             category: '', mainIngredient: '', FMP: '', cookingMethod: '',
//             byThePan: '', dietaryRestrictions: '', cuisineType: '', holiday: '', rating: '',
//         };
//         setFilters(cleared);
//         setPriceState({ values: [priceRange.low, priceRange.high] });
//         dispatch(query_products({ webSiteOrigin: sellerFrontEndURL, low: priceRange.low, high: priceRange.high, sortPrice, pageNumber, ...cleared }));
//         dispatch(price_range_product(sellerFrontEndURL));
//     };

//     const resetSingleFilter = (key) => {
//         setFilter(key, '');
//         dispatch(makeQueryAction({ [key]: '' }));
//     };

//     const resetPriceRange = () => {
//         setPriceState({ values: [priceRange.low, priceRange.high] });
//         dispatch(price_range_product(sellerFrontEndURL));
//     };

//     const queryFilter = (key, value, checked) => setFilter(key, checked ? value : '');

//     return {
//         filters, priceState, setPriceState, intPriceRangeStep,
//         resetAllFilters, resetSingleFilter, resetPriceRange, queryFilter,
//     };
// }

// // ---------------------------------------------------------------------------
// // FilterSection – same structure, polished details
// // ---------------------------------------------------------------------------
// function FilterSection({ title, primaryColor, secondaryColor, open = false, onClearThis, onClearAll, children }) {
//     const triggerBase = (isOpen) => (
//         <div
//             className="trigger-wrapper flex items-center justify-between w-full px-2.5 py-2 
//                 transition-colors cursor-pointer"
//             style={{ color: primaryColor, backgroundColor: secondaryColor }}>
//             {/* backgroundColor: primaryColor + '32'  */}
//             <span className="font-semibold text-[13px] tracking-wide ml-2 mt-0.5 mb-0.5">{title}</span>
//             <span
//                 className="opacity-100 font-bold mr-1"
//                 style={{
//                     display: 'inline-flex',
//                     transform: isOpen ? 'rotate(0deg)' : 'rotate(180deg)',
//                     transition: 'transform 0.4s ease',
//                 }}>
//                 <HiChevronUp size={18} />
//             </span>
//         </div>
//     );
   
//     // const triggerBase = (isOpen) => (
//     //     <div
//     //         className="trigger-wrapper flex items-center justify-between w-full px-2.5 py-2 
//     //             transition-colors cursor-pointer"
//     //         style={{ color: primaryColor, backgroundColor: primaryColor + '12' }}>
//     //         <span className="font-semibold text-[13px] tracking-wide ml-2">{title}</span>
//     //         <span className="opacity-100 font-bold mr-1">
//     //             {isOpen ? <HiChevronUp size={18} /> : <HiChevronDown size={18} />}
//     //         </span>
//     //     </div>
//     // );

//     return (
//         <div
//             className="border rounded-md mb-2 overflow-hidden"
//             style={{ borderColor: primaryColor + '88', backgroundColor: secondaryColor }}>
//             <Collapsible
//                 trigger={triggerBase(false)}
//                 triggerWhenOpen={triggerBase(true)}
//                 transitionTime={250}
//                 easing="ease-in-out"
//                 contentOuterClassName="overflow-hidden"
//                 open={open}>
//                 <div className="px-2 pt-1.5 pb-0.5">
//                     {children}
//                 </div>
//                 <div
//                     className="flex gap-1.5 px-2 py-1.5"
//                     style={{ borderTop: `1px solid ${primaryColor}22` }}>
//                     <button
//                         onClick={onClearThis}
//                         className="flex-1 flex items-center justify-center gap-1 py-1 rounded-md text-[11px] 
//                         font-medium border hover:font-bold text-white transition-opacity hover:opacity-90"
//                         style={{ backgroundColor: primaryColor, borderColor: primaryColor }}>
//                         <MdFilterListOff size={16} /> Clear This Filter
//                     </button>
//                     <button
//                         onClick={onClearAll}
//                         className="flex-1 flex items-center justify-center gap-1 py-1 rounded-md text-[11px] 
//                         font-medium border hover:font-bold transition-opacity hover:opacity-80"
//                         style={{
//                             color: primaryColor,
//                             borderColor: primaryColor,
//                             backgroundColor: 'white',
//                         }}>
//                         <MdFilterListOff size={16} /> Clear All Filters
//                     </button>
//                 </div>
//             </Collapsible>
//         </div>
//     );
// }

// // ---------------------------------------------------------------------------
// // CheckboxList – same grid, polished hover row
// // ---------------------------------------------------------------------------
// function CheckboxList({ items, activeValue, filterItemTextSize, primaryColor, onChange, secondaryColor }) {
//     return (
//         <div className="grid grid-cols-2 gap-0.5 pt-1.5 border-t-2"
//             style={{ backgroundColor: primaryColor + '05', borderColor: primaryColor }}>
//             {items.sort().map((value) => (
//                 <label
//                     key={value}
//                     className="flex items-center gap-1.5 px-1.5 py-1.5 rounded-md cursor-pointer 
//                     transition-colors hover:bg-black/15 border border-black"
//                     style={{ 
//                         backgroundColor: activeValue === value ? secondaryColor : undefined,
//                         borderColor: activeValue === value ? primaryColor : 'transparent'
//                     }}>
//                     {/*  backgroundColor: activeValue === value ? primaryColor + '15' : undefined,  */}
//                     <input
//                         type="checkbox"
//                         id={value}
//                         style={{ accentColor: primaryColor }}
//                         checked={activeValue === value}
//                         onChange={(e) => onChange(value, e.target.checked)}
//                         className="shrink-0"
//                     />
//                     <span
//                         className="break-words leading-tight"
//                         style={{ color: primaryColor, fontSize: filterItemTextSize || '12px' }}>
//                         {value}
//                     </span>
//                 </label>
//             ))}
//         </div>
//     );
// }

// // ---------------------------------------------------------------------------
// // ActiveFilterChips – new: dismissible pill tags in the toolbar
// // ---------------------------------------------------------------------------
// function ActiveFilterChips({ filters, sellerMainIngredientTerm, primaryColor, onRemove }) {
//     const labelMap = {
//         category: 'Category',
//         mainIngredient: sellerMainIngredientTerm || 'Ingredient',
//         FMP: 'FMP',
//         cookingMethod: 'Cooking',
//         byThePan: 'By Pan',
//         dietaryRestrictions: 'Dietary',
//         cuisineType: 'Cuisine',
//         holiday: 'Holiday',
//         rating: 'Rating',
//     };

//     const active = Object.entries(filters).filter(([, v]) => v !== '');
//     if (!active.length) return null;

//     return (
//         <div className="flex flex-wrap gap-1.5">
//             {active.map(([key, value]) => (
//                 <span
//                     key={key}
//                     className="inline-flex items-center gap-1 pl-2.5 pr-1 py-0.5 rounded-full text-[11px] 
//                     font-medium text-white"
//                     style={{ backgroundColor: primaryColor }}>
//                     {labelMap[key]}: {key === 'rating' ? `${value}★` : value}
//                     <button
//                         onClick={() => onRemove(key)}
//                         className="rounded-full p-0.5 hover:bg-white/25 transition-colors"
//                         aria-label={`Remove ${labelMap[key]}`}
//                     >
//                         <IoClose size={11} />
//                     </button>
//                 </span>
//             ))}
//         </div>
//     );
// }

// // ---------------------------------------------------------------------------
// // Main component
// // ---------------------------------------------------------------------------
// const Shops = () => {
//     const sellerFrontEndURL = config.STR_FRONTEND_URL;
//     const filterItemTextSize = '12px';

//     const { categorys, allSiteProducts, products, priceRange, latest_product, totalProduct, parPage } =
//         useSelector(state => state.home);
//     const { seller } = useSelector(state => state.seller);
//     const { userInfo } = useSelector(state => state.auth);

//     const navigate = useNavigate();
//     const dispatch = useDispatch();
//     const { holidayURLParam } = useParams();
    
//     const { 
//         sellerComponentBackgroundColor,
//     } = GetSellerConfig();

//     // const { 
//     //     sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
//     //     sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
//     //     sellerShopName, sellerStripePaymentMode, sellerOtherWebsiteURL1, sellerOtherWebsiteName1, 
//     //     sellerOtherWebsiteURL2, sellerOtherWebsiteName2, sellerProductTerm, sellerProductPluralTerm,
//     //     sellerCompanyPhoneNumber, sellerCompanyLogo,sellerSellerImage, sellerBeforeYouRegister1, sellerPhoneNumber,
//     //     sellerCompanyEmailAddress, sellerCompanyKosherSupervision1, 
//     //     sellerCompanyKosherSupervision2, sellerMainIngredientPluralTerm, sellerTaglineTop1, sellerTaglineTop2, 
//     //     personalServiceTagLine, sellerMarketingLine1, sellerHolidayHeader, sellerOwnerNames,
//     //     sellerBoolShowSiteWishList, sellerBoolShowSiteChat, sellerBoolShowGalleryImages, sellerBoolShowSocialMedia
//     // } = GetSellerConfig();

//     const sellerPrimaryColor1 = seller?.frontEndPrimaryColor1;
//     const sellerSecondaryColor1 = seller?.frontEndSecondaryColor1;

//     const sellerArrHexOpacityColorSuffixes = seller?.hexOpacityColorSuffixes?.split(';') || [];
//     const sellerColorSuffixDark   = sellerArrHexOpacityColorSuffixes[0] || 'FF';
//     const sellerColorSuffixMedium = sellerArrHexOpacityColorSuffixes[1] || '80';
//     const sellerColorSuffixLight  = sellerArrHexOpacityColorSuffixes[2] || '1A';
    
//     const sellerMainIngredientTerm = seller?.mainIngredientTerm;
//     const sellerMainIngredientPluralTerm = seller?.mainIngredientPluralTerm;
//     const sellerProductTerm = seller?.productTerm;
//     const sellerProductPluralTerm = seller?.productPluralTerm;
//     const isVisible = (flag) => seller?.[flag] === 'Show';

//     const [showFilterPanel, setShowFilterPanel] = useState(true);
//     const [styles, setStyles] = useState('grid');
//     const [pageNumber, setPageNumber] = useState(1);
//     const [sortPrice, setSortPrice] = useState('');

//     const {
//         filters, priceState, setPriceState, intPriceRangeStep,
//         resetAllFilters, resetSingleFilter, resetPriceRange, queryFilter,
//     } = useShopFilters(sellerFrontEndURL, priceRange, sortPrice, pageNumber);

//     useEffect(() => {
//         if (holidayURLParam) queryFilter('holiday', holidayURLParam, true);
//     }, []); // eslint-disable-line react-hooks/exhaustive-deps

//     useEffect(() => {
//         dispatch(price_range_product(sellerFrontEndURL));
//     }, [sellerFrontEndURL]); // eslint-disable-line react-hooks/exhaustive-deps

//     const filterOptions = useMemo(() => {
//         const unique = (key, exclude) =>
//             [...new Set(allSiteProducts.map(p => p[key]).filter(v => v && v !== exclude))];
//         return {
//             categories: unique('category'),
//             mainIngredients: unique('mainIngredient'),
//             FMPs: unique('FMP'),
//             cookingMethods: unique('cookingMethod'),
//             byThePans: unique('byThePan', 'NoPan'),
//             dietaryRestrictions: unique('dietaryRestrictions', 'None'),
//             cuisineTypes: unique('cuisineType'),
//             holidays: unique('holiday', 'None'),
//         };
//     }, [allSiteProducts]);

//     const goTo = (authPath, guestPath = '/login') =>
//         navigate(userInfo ? authPath : guestPath);

//     const activeFilterCount = Object.values(filters).filter(v => v !== '').length;

//     const sharedFilterProps = {
//         primaryColor: sellerPrimaryColor1,
//         secondaryColor: sellerSecondaryColor1,
//         onClearAll: resetAllFilters,
//     };

//     const checkboxProps = (key) => ({
//         activeValue: filters[key],
//         filterItemTextSize,
//         primaryColor: sellerPrimaryColor1,
//         onChange: (value, checked) => queryFilter(key, value, checked),
//     });

//     return (
//         <div>
//             <style>{`
//                 .Collapsible__contentInner { background-color: ${sellerSecondaryColor1}; }
//                 .Collapsible__contentOuter { cursor: default; }
//                 .trigger-wrapper { padding: 0; }
//             `}</style>

//             <Header />
//             <section className="">
//                 <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
//                     <div className="">
//                         <ShopBanner
//                             homePage="Home" homeLink="/"
//                             currentPageTop={`All ${sellerProductPluralTerm}`} currentPageTopLink=""
//                             currentPageBottom1={`All ${sellerProductPluralTerm}`} currentPageBottomLink1=""
//                             currentPageBottom2="" currentPageBottomLink2=""
//                         />
//                     </div>

//                     {/* Mobile filter toggle */}
//                     <div className={`md:block hidden ${showFilterPanel ? 'mb-0' : 'mb-6'}`}>
//                         <button
//                             onClick={() => setShowFilterPanel(!showFilterPanel)}
//                             className="flex items-center justify-center gap-1.5 w-full py-2.5 px-3 rounded-lg text-white font-medium shadow-sm transition-opacity hover:opacity-90"
//                             style={{ backgroundColor: sellerPrimaryColor1 }}>
//                             <IoFilterSharp size={15} />
//                             Filter {sellerProductPluralTerm}
//                             {activeFilterCount > 0 && (
//                                 <span className="bg-white/25 text-white text-[11px] font-bold px-1.5 py-0.5 rounded-full leading-none">
//                                     {activeFilterCount}
//                                 </span>
//                             )}
//                             {showFilterPanel ? <FaCaretDown className="text-lg ml-0.5" /> : <FaCaretUp className="text-lg ml-0.5" />}
//                         </button>
//                     </div>

//                     <div className="w-full border-none flex flex-wrap">
//                         {/* ── Sidebar ── */}
//                         <div className={`border-none w-3/12 md-lg:w-4/12 md:w-full pr-8
//                             ${showFilterPanel ? 'md:h-0 md:overflow-hidden md:mb-6' : 'md:h-auto md:overflow-auto md:mb-0'}`}>

//                             <div
//                                 className={`${showFilterPanel ? 'flex' : 'hidden'} 
//                                     items-center gap-1.5 text-lg font-bold mb-3`}
//                                 style={{ color: sellerPrimaryColor1 }}>
//                                 <IoFilterSharp size={22} />
//                                 Filter {sellerProductPluralTerm}
//                                 {activeFilterCount > 0 && (
//                                     <span
//                                         className="text-[11px] font-bold text-white px-1.5 py-0.5 rounded-full leading-none"
//                                         style={{ backgroundColor: sellerPrimaryColor1 }}>
//                                         {activeFilterCount}
//                                     </span>
//                                 )}
//                             </div>

//                             <FilterSection title="Categories" {...sharedFilterProps} onClearThis={() => resetSingleFilter('category')}>
//                                 <CheckboxList items={filterOptions.categories} {...checkboxProps('category')} />
//                             </FilterSection>

//                             <FilterSection title={sellerMainIngredientPluralTerm} {...sharedFilterProps} onClearThis={() => resetSingleFilter('mainIngredient')}>
//                                 <CheckboxList items={filterOptions.mainIngredients} {...checkboxProps('mainIngredient')} />
//                             </FilterSection>

//                             <FilterSection title="Fleishig / Meat / Parve" {...sharedFilterProps} onClearThis={() => resetSingleFilter('FMP')}>
//                                 <CheckboxList items={filterOptions.FMPs} {...checkboxProps('FMP')} />
//                             </FilterSection>

//                             {isVisible('isVisibleSiteCookingMethods') && (
//                                 <FilterSection title="Cooking Method" {...sharedFilterProps} onClearThis={() => resetSingleFilter('cookingMethod')}>
//                                     <CheckboxList items={filterOptions.cookingMethods} {...checkboxProps('cookingMethod')} />
//                                 </FilterSection>
//                             )}

//                             {filterOptions.byThePans.length > 0 && (
//                                 <FilterSection title="By The Pan" {...sharedFilterProps} onClearThis={() => resetSingleFilter('byThePan')}>
//                                     <CheckboxList items={filterOptions.byThePans} {...checkboxProps('byThePan')} />
//                                 </FilterSection>
//                             )}

//                             {filterOptions.dietaryRestrictions.length > 0 && (
//                                 <FilterSection title="Dietary Restrictions" {...sharedFilterProps} onClearThis={() => resetSingleFilter('dietaryRestrictions')}>
//                                     <CheckboxList items={filterOptions.dietaryRestrictions} {...checkboxProps('dietaryRestrictions')} />
//                                 </FilterSection>
//                             )}

//                             {isVisible('isVisibleSiteCuisineType') && (
//                                 <FilterSection title="Cuisine Type" {...sharedFilterProps} onClearThis={() => resetSingleFilter('cuisineType')}>
//                                     <CheckboxList items={filterOptions.cuisineTypes} {...checkboxProps('cuisineType')} />
//                                 </FilterSection>
//                             )}

//                             {isVisible('isVisibleSiteHoliday') && (
//                                 <FilterSection
//                                     title="Holidays"
//                                     {...sharedFilterProps}
//                                     onClearThis={() => resetSingleFilter('holiday')}
//                                     open={!!holidayURLParam}
//                                 >
//                                     <CheckboxList items={filterOptions.holidays} {...checkboxProps('holiday')} />
//                                 </FilterSection>
//                             )}

//                             {isVisible('isVisibleSitePayments') && (
//                                 <FilterSection title="Price Range" {...sharedFilterProps} onClearThis={resetPriceRange}>
//                                     <div className="p-2 flex flex-col gap-2">
//                                         <Range
//                                             step={intPriceRangeStep}
//                                             min={priceRange.low}
//                                             max={priceRange.high}
//                                             values={[
//                                                 Math.min(Math.max(priceState.values[0], priceRange.low), priceRange.high),
//                                                 Math.min(Math.max(priceState.values[1], priceRange.low), priceRange.high),
//                                             ]}
//                                             onChange={(values) => setPriceState({ values })}
//                                             renderTrack={({ props, children }) => (
//                                                 <div {...props} className="w-full h-[5px] bg-slate-200 rounded-full cursor-pointer">
//                                                     {children}
//                                                 </div>
//                                             )}
//                                             renderThumb={({ props }) => (
//                                                 <div
//                                                     className="w-[14px] h-[14px] rounded-full border-2 border-white shadow"
//                                                     style={{ backgroundColor: sellerPrimaryColor1 }}
//                                                     {...props}
//                                                 />
//                                             )}
//                                         />
//                                         <span className="font-semibold text-base" style={{ color: sellerPrimaryColor1 }}>
//                                             ${Math.floor(priceState.values[0])} – ${Math.floor(priceState.values[1])}
//                                         </span>
//                                     </div>
//                                 </FilterSection>
//                             )}

//                             {isVisible('isVisibleSiteRating') && (
//                                 <FilterSection title="Rating" {...sharedFilterProps} onClearThis={() => resetSingleFilter('rating')}>
//                                     <div className="py-2 flex flex-col gap-0.5">
//                                         {[5, 4, 3, 2, 1].map((n) => (
//                                             <div
//                                                 key={n}
//                                                 onClick={() => queryFilter('rating', n, true)}
//                                                 className="flex items-center gap-1 px-1.5 py-1.5 rounded-md cursor-pointer transition-colors hover:bg-black/5"
//                                                 style={{
//                                                     backgroundColor: filters.rating === n ? sellerPrimaryColor1 + '15' : undefined,
//                                                 }}
//                                             >
//                                                 {Array.from({ length: 5 }, (_, i) =>
//                                                     i < n
//                                                         ? <AiFillStar key={i} className="text-amber-400 text-[15px]" />
//                                                         : <CiStar key={i} className="text-gray-300 text-[15px]" />
//                                                 )}
//                                                 <span className="text-[11px] text-gray-400 ml-0.5">& up</span>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 </FilterSection>
//                             )}

//                             {/* Action buttons */}
//                             <div className="flex flex-col gap-1.5 mt-3">
//                                 <button
//                                     onClick={resetAllFilters}
//                                     className="flex items-center justify-center gap-1.5 w-full py-2 px-4 rounded-lg 
//                                     text-white text-[16px] font-semibold shadow-sm transition-opacity hover:opacity-85"
//                                     style={{ backgroundColor: sellerPrimaryColor1 }}>
//                                     <MdFilterListOff size={24} /> Clear All Filters
//                                 </button>
//                                 <button
//                                     onClick={() => goTo('/customerDashboard/sampleMenus')}
//                                     className="flex items-center justify-center gap-1 w-full py-2 px-4 rounded-lg 
//                                     text-[16px] font-semibold border transition-opacity hover:opacity-80"
//                                     style={{
//                                         color: sellerPrimaryColor1,
//                                         borderColor: sellerPrimaryColor1 + '55',
//                                         backgroundColor: sellerPrimaryColor1 + '18',
//                                     }}>
//                                     <MdOutlineRestaurantMenu size={24} /> Sample Menus
//                                 </button>
//                                 <button
//                                     onClick={() => goTo('/customerDashboard/sellerPackages')}
//                                     className="flex items-center justify-center gap-1.5 w-full py-2 px-4 rounded-lg 
//                                     text-[16px] font-semibold border transition-opacity hover:opacity-80"
//                                     style={{
//                                         color: sellerPrimaryColor1,
//                                         borderColor: sellerPrimaryColor1 + '55',
//                                         backgroundColor: sellerPrimaryColor1 + '18',
//                                     }}>
//                                     <FaGift size={18} /> Packages
//                                 </button>
//                             </div>

//                             {isVisible('isVisibleSiteProductsUnderFilter') && (
//                                 <div
//                                     className="py-3 flex gap-4 md:hidden border-2 rounded-lg mt-3 justify-center items-center"
//                                     style={{ borderColor: sellerPrimaryColor1 + '40' }}>
//                                     <Products title={`Latest ${sellerProductPluralTerm}`} products={latest_product} parentPage="Shops" />
//                                 </div>
//                             )}
//                         </div>

//                         {/* ── Product Grid ── */}
//                         <div className="w-9/12 md-lg:w-8/12 md:w-full">
//                             <div className="pl-2 md:pl-0">

//                                 {/* Toolbar */}
//                                 <div
//                                     className="px-3 py-1 mb-2 gap-0.5 rounded-lg border flex flex-col"
//                                     style={{
//                                         borderColor: sellerPrimaryColor1 + '55',
//                                         backgroundColor: sellerSecondaryColor1,
//                                     }}>
//                                     {/* Row 1: count + sort + toggle */}
//                                     <div className="flex items-center justify-between gap-2 border-none border-black">
//                                         <div className="text-[18px] font-medium md-lg:hidden" 
//                                             style={{ color: sellerPrimaryColor1 }}>
//                                             {totalProduct} {sellerProductTerm}{totalProduct !== 1 ? 's' : ''}
//                                         </div>

//                                         <div className="flex items-center gap-2 ml-auto">
//                                             {isVisible('isVisibleSitePayments') && (
//                                                 <select
//                                                     onChange={(e) => setSortPrice(e.target.value)}
//                                                     className="py-1.5 px-2.5 rounded-lg border text-sm font-medium outline-none bg-white"
//                                                     style={{
//                                                         color: sellerPrimaryColor1,
//                                                         borderColor: sellerPrimaryColor1 + '55',
//                                                     }}>
//                                                     <option value="">Sort By</option>
//                                                     <option value="low-to-high">Price: Low → High</option>
//                                                     <option value="high-to-low">Price: High → Low</option>
//                                                 </select>
//                                             )}

//                                             {/* Grid / List toggle */}
//                                             <div
//                                                 className="flex rounded-lg border overflow-hidden md-lg:hidden"
//                                                 style={{ borderColor: sellerPrimaryColor1 + '55' }}>
//                                                 <button
//                                                     onClick={() => setStyles('grid')}
//                                                     className="p-1.5 transition-colors"
//                                                     style={{
//                                                         backgroundColor: styles === 'grid' ? sellerPrimaryColor1 + '20' : 'white',
//                                                         color: sellerPrimaryColor1,
//                                                     }}>
//                                                     <BsFillGridFill size={16} />
//                                                 </button>
//                                                 <button
//                                                     onClick={() => setStyles('list')}
//                                                     className="p-1.5 transition-colors"
//                                                     style={{
//                                                         backgroundColor: styles === 'list' ? sellerPrimaryColor1 + '20' : 'white',
//                                                         color: sellerPrimaryColor1,
//                                                         borderLeft: `1px solid ${sellerPrimaryColor1}35`,
//                                                     }}>
//                                                     <FaThList size={16} />
//                                                 </button>
//                                             </div>
//                                         </div>
//                                     </div>

//                                     {/* Row 2: active filter chips (only when filters are active) */}
//                                     {activeFilterCount > 0 && (
//                                         <div className="md-lg:hidden border-none border-black">
//                                             <ActiveFilterChips
//                                                 filters={filters}
//                                                 sellerMainIngredientTerm={sellerMainIngredientTerm}
//                                                 primaryColor={sellerPrimaryColor1}
//                                                 onRemove={resetSingleFilter}
//                                             />
//                                         </div>
//                                     )}
//                                 </div>

//                                 <div className="pb-8">
//                                     <ShopProductGridListView products={products} styles={styles} />
//                                 </div>

//                                 {totalProduct > parPage && (
//                                     //pageNumber, setPageNumber, totalItems, itemsPerPage, showItem
//                                     //pageNumber, setPageNumber, totalItems, itemsPerPage, showItem
//                                     // console.log('Rendering Pagination with:', {
//                                     //     pageNumber: pageNumber,
//                                     //     setPageNumber: setPageNumber,
//                                     //     totalItems: totalProduct,
//                                     //     parPage: parPage,
//                                     //     showItem: Math.floor(totalProduct / parPage),
//                                     // }),
//                                     <Pagination
//                                         pageNumber={pageNumber}
//                                         setPageNumber={setPageNumber}
//                                         totalItems={totalProduct}
//                                         parPage={parPage}
//                                         showItem={Math.floor(totalProduct / parPage)}
//                                     />
//                                 )}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//             <Footer />
//         </div>
//     );
// };

// export default Shops;







//before redesign
// import React, { useEffect, useState, useMemo } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { useNavigate, useParams } from 'react-router-dom';

// import { Range } from 'react-range';
// import { AiFillStar } from 'react-icons/ai';
// import { CiStar } from 'react-icons/ci';
// import { BsFillGridFill } from 'react-icons/bs';
// import { FaThList, FaCaretDown, FaCaretUp, FaGift } from 'react-icons/fa';
// import { MdOutlineRestaurantMenu, MdFilterListOff } from 'react-icons/md';
// import { IoFilterSharp } from 'react-icons/io5';
// import { HiChevronUp, HiChevronDown } from 'react-icons/hi2';
// import Collapsible from 'react-collapsible';

// import { price_range_product, query_products } from '../store/reducers/homeReducer';
// import Products from '../components/products/Products';
// import ShopProductGridListView from '../components/products/ShopProductGridListView';
// import Pagination from '../components/Pagination';
// import Header from '../components/Header';
// import Footer from '../components/Footer';
// import ShopBanner from '../components/ShopBanner';
// import config from '../config';

// // ---------------------------------------------------------------------------
// // Custom hook – all filter state & dispatch logic lives here
// // ---------------------------------------------------------------------------
// function useShopFilters(sellerFrontEndURL, priceRange, sortPrice, pageNumber) {
//     const dispatch = useDispatch();
//     const intPriceRangeStep = config.INT_FRONTEND_PRICE_RANGE_STEP;

//     const [priceState, setPriceState] = useState({ values: [priceRange.low, priceRange.high] });
//     useEffect(() => {
//         setPriceState({ values: [priceRange.low, priceRange.high] });
//     }, [priceRange]);

//     const [filters, setFilters] = useState({
//         category: '',
//         mainIngredient: '',
//         FMP: '',
//         cookingMethod: '',
//         byThePan: '',
//         dietaryRestrictions: '',
//         cuisineType: '',
//         holiday: '',
//         rating: '',
//     });

//     const setFilter = (key, value) =>
//         setFilters(prev => ({ ...prev, [key]: value }));

//     const makeQueryAction = (overrides = {}) =>
//         query_products({
//             webSiteOrigin: sellerFrontEndURL,
//             low: priceState.values[0],
//             high: priceState.values[1],
//             sortPrice,
//             pageNumber,
//             ...filters,
//             ...overrides,
//         });

//     // Fired whenever any filter changes
//     useEffect(() => {
//         dispatch(makeQueryAction());
//     }, [
//         sellerFrontEndURL,
//         priceState.values[0],
//         priceState.values[1],
//         filters.category,
//         filters.mainIngredient,
//         filters.FMP,
//         filters.cookingMethod,
//         filters.byThePan,
//         filters.dietaryRestrictions,
//         filters.cuisineType,
//         filters.holiday,
//         filters.rating,
//         sortPrice,
//         pageNumber,
//     ]);

//     const resetAllFilters = () => {
//         const cleared = {
//             category: '', mainIngredient: '', FMP: '', cookingMethod: '',
//             byThePan: '', dietaryRestrictions: '', cuisineType: '', holiday: '', rating: '',
//         };
//         setFilters(cleared);
//         dispatch(query_products({ webSiteOrigin: sellerFrontEndURL, low: priceState.values[0], high: priceState.values[1], sortPrice, pageNumber, ...cleared }));
//         dispatch(price_range_product(sellerFrontEndURL));
//     };

//     const resetSingleFilter = (key) => {
//         setFilter(key, '');
//         dispatch(makeQueryAction({ [key]: '' }));
//     };

//     const resetPriceRange = () => dispatch(price_range_product(sellerFrontEndURL));

//     // Checkbox toggle helper (only one value active at a time)
//     const queryFilter = (key, value, checked) =>
//         setFilter(key, checked ? value : '');

//     return {
//         filters,
//         priceState,
//         setPriceState,
//         intPriceRangeStep,
//         resetAllFilters,
//         resetSingleFilter,
//         resetPriceRange,
//         queryFilter,
//     };
// }

// // ---------------------------------------------------------------------------
// // Reusable collapsible filter section
// // ---------------------------------------------------------------------------
// function FilterSection({ title, primaryColor, secondaryColor, open = false, onClearThis, onClearAll, children }) {
//     const triggerBase = (isOpen) => (
//         <div
//             className={`trigger-wrapper flex items-center justify-between w-full ${isOpen ? 'rounded-t-md' : 'rounded-md'} transition-all cursor-pointer`}
//             style={{ borderColor: primaryColor, color: primaryColor, backgroundColor: secondaryColor }}
//         >
//             <span className="font-semibold pl-1 text-[15px]">{title}</span>
//             {isOpen ? <HiChevronUp size={24} className="font-bold" /> : <HiChevronDown size={24} className="font-bold" />}
//         </div>
//     );

//     return (
//         <div
//             className="p-1 border rounded-md mb-2"
//             style={{ borderColor: primaryColor, color: primaryColor, backgroundColor: secondaryColor }}
//         >
//             <Collapsible
//                 trigger={triggerBase(false)}
//                 triggerWhenOpen={triggerBase(true)}
//                 transitionTime={300}
//                 easing="ease-in-out"
//                 contentOuterClassName="overflow-hidden"
//                 open={open}
//             >
//                 {children}
//                 <div className="w-full flex justify-center items-center mt-0.5">
//                     <button
//                         onClick={onClearThis}
//                         className="w-[50%] flex text-nowrap items-center justify-center m-0.5 text-center rounded-md text-[11px] p-0.5 text-white"
//                         style={{ backgroundColor: primaryColor }}
//                     >
//                         <MdFilterListOff size={12} className="mr-1" /> Clear This Filter
//                     </button>
//                     <button
//                         onClick={onClearAll}
//                         className="w-[50%] flex text-nowrap items-center justify-center m-0.5 text-center rounded-md text-[11px] p-0.5 text-white"
//                         style={{ backgroundColor: primaryColor }}
//                     >
//                         <MdFilterListOff size={12} className="mr-1" /> Clear All Filters
//                     </button>
//                 </div>
//             </Collapsible>
//         </div>
//     );
// }

// // Checkbox list used inside FilterSection
// function CheckboxList({ items, activeValue, filterItemTextSize, primaryColor, onChange }) {
//     return (
//         <div className="grid grid-cols-2 gap-1">
//             {items.sort().map((value) => (
//                 <div key={value} className="ml-0.5 p-0.5 w-full flex justify-start items-center gap-1 py-1">
//                     <input
//                         type="checkbox"
//                         id={value}
//                         style={{ accentColor: primaryColor }}
//                         checked={activeValue === value}
//                         onChange={(e) => onChange(value, e.target.checked)}
//                     />
//                     <label
//                         className="break-words cursor-pointer"
//                         style={{ color: primaryColor, fontSize: filterItemTextSize }}
//                         htmlFor={value}
//                     >
//                         {value}
//                     </label>
//                 </div>
//             ))}
//         </div>
//     );
// }

// // ---------------------------------------------------------------------------
// // Main component
// // ---------------------------------------------------------------------------
// const Shops = () => {
//     const sellerFrontEndURL = config.STR_FRONTEND_URL;
//     const filterItemTextSize = '12px';

//     const { categorys, allSiteProducts, products, priceRange, latest_product, totalProduct, parPage } =
//         useSelector(state => state.home);
//     const { seller } = useSelector(state => state.seller);
//     const { userInfo } = useSelector(state => state.auth);

//     const navigate = useNavigate();
//     const dispatch = useDispatch();
//     const { holidayURLParam } = useParams();

//     // Seller settings
//     const sellerPrimaryColor1 = seller?.frontEndPrimaryColor1;
//     const sellerSecondaryColor1 = seller?.frontEndSecondaryColor1;
//     const sellerMainIngredientTerm = seller?.mainIngredientTerm;
//     const sellerMainIngredientPluralTerm = seller?.mainIngredientPluralTerm;
//     const sellerProductTerm = seller?.productTerm;
//     const sellerProductPluralTerm = seller?.productPluralTerm;
//     const isVisible = (flag) => seller?.[flag] === 'Show';

//     const [showFilterPanel, setShowFilterPanel] = useState(true);
//     const [styles, setStyles] = useState('grid');
//     const [pageNumber, setPageNumber] = useState(1);
//     const [sortPrice, setSortPrice] = useState('');

//     const {
//         filters, priceState, setPriceState, intPriceRangeStep,
//         resetAllFilters, resetSingleFilter, resetPriceRange, queryFilter,
//     } = useShopFilters(sellerFrontEndURL, priceRange, sortPrice, pageNumber);

//     // Initialise holiday from URL param (once on mount)
//     useEffect(() => {
//         if (holidayURLParam) queryFilter('holiday', holidayURLParam, true);
//     }, []); // eslint-disable-line react-hooks/exhaustive-deps

//     // Fetch price range on mount
//     useEffect(() => {
//         dispatch(price_range_product(sellerFrontEndURL));
//     }, [sellerFrontEndURL]); // eslint-disable-line react-hooks/exhaustive-deps

//     // Derive unique filter option arrays from allSiteProducts (not during render)
//     const filterOptions = useMemo(() => {
//         const unique = (key, exclude) =>
//             [...new Set(allSiteProducts.map(p => p[key]).filter(v => v && v !== exclude))];
//         return {
//             categories: unique('category'),
//             mainIngredients: unique('mainIngredient'),
//             FMPs: unique('FMP'),
//             cookingMethods: unique('cookingMethod'),
//             byThePans: unique('byThePan', 'NoPan'),
//             dietaryRestrictions: unique('dietaryRestrictions', 'None'),
//             cuisineTypes: unique('cuisineType'),
//             holidays: unique('holiday', 'None'),
//         };
//     }, [allSiteProducts]);

//     const goTo = (authPath, guestPath = '/login') =>
//         navigate(userInfo ? authPath : guestPath);

//     const sharedFilterProps = {
//         primaryColor: sellerPrimaryColor1,
//         secondaryColor: sellerSecondaryColor1,
//         onClearAll: resetAllFilters,
//     };

//     const checkboxProps = (key) => ({
//         activeValue: filters[key],
//         filterItemTextSize,
//         primaryColor: sellerPrimaryColor1,
//         onChange: (value, checked) => queryFilter(key, value, checked),
//     });

//     return (
//         <div>
//             <style>{`
//                 .Collapsible__contentInner { background-color: ${sellerSecondaryColor1}; }
//                 .Collapsible__contentOuter { cursor: default; }
//                 .trigger-wrapper { padding: 0px; }
//             `}</style>

//             <Header />
//             <section className="py-2">
//                 <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
//                     <div className="mb-4">
//                         <ShopBanner
//                             homePage="Home" homeLink="/"
//                             currentPageTop={`All ${sellerProductPluralTerm}`} currentPageTopLink=""
//                             currentPageBottom1={`All ${sellerProductPluralTerm}`} currentPageBottomLink1=""
//                             currentPageBottom2="" currentPageBottomLink2=""
//                         />
//                     </div>

//                     {/* Mobile filter toggle */}
//                     <div className={`md:block hidden ${showFilterPanel ? 'mb-0' : 'mb-6'}`}>
//                         <button
//                             onClick={() => setShowFilterPanel(!showFilterPanel)}
//                             className="flex items-center justify-center text-center rounded-lg w-full py-2 px-3 text-white"
//                             style={{ backgroundColor: sellerPrimaryColor1 }}
//                         >
//                             <IoFilterSharp className="mr-1" />Filter {sellerProductPluralTerm}
//                             {showFilterPanel ? <FaCaretDown className="text-2xl ml-1" /> : <FaCaretUp className="text-2xl ml-1" />}
//                         </button>
//                     </div>

//                     <div className="w-full border-none flex flex-wrap">
//                         {/* ── Sidebar ── */}
//                         <div className={`border-none w-3/12 md-lg:w-4/12 md:w-full pr-8
//                             ${showFilterPanel ? 'md:h-0 md:overflow-hidden md:mb-6' : 'md:h-auto md:overflow-auto md:mb-0'}`}>

//                             <div className={`${showFilterPanel ? 'flex' : 'hidden'} text-xl font-bold mb-3`}
//                                 style={{ color: sellerPrimaryColor1 }}>
//                                 <IoFilterSharp className="mr-1 mt-1" /> Filter {sellerProductPluralTerm}
//                             </div>

//                             {/* Categories */}
//                             <FilterSection title="Categories" {...sharedFilterProps} onClearThis={() => resetSingleFilter('category')}>
//                                 <CheckboxList items={filterOptions.categories} {...checkboxProps('category')} />
//                             </FilterSection>

//                             {/* Main Ingredient */}
//                             <FilterSection title={sellerMainIngredientPluralTerm} {...sharedFilterProps} onClearThis={() => resetSingleFilter('mainIngredient')}>
//                                 <CheckboxList items={filterOptions.mainIngredients} {...checkboxProps('mainIngredient')} />
//                             </FilterSection>

//                             {/* FMP */}
//                             <FilterSection title="Fleishig / Meat / Parve" {...sharedFilterProps} onClearThis={() => resetSingleFilter('FMP')}>
//                                 <CheckboxList items={filterOptions.FMPs} {...checkboxProps('FMP')} />
//                             </FilterSection>

//                             {/* Cooking Method */}
//                             {isVisible('isVisibleSiteCookingMethods') && (
//                                 <FilterSection title="Cooking Method" {...sharedFilterProps} onClearThis={() => resetSingleFilter('cookingMethod')}>
//                                     <CheckboxList items={filterOptions.cookingMethods} {...checkboxProps('cookingMethod')} />
//                                 </FilterSection>
//                             )}

//                             {/* By The Pan */}
//                             {filterOptions.byThePans.length > 0 && (
//                                 <FilterSection title="By The Pan" {...sharedFilterProps} onClearThis={() => resetSingleFilter('byThePan')}>
//                                     <div className="grid grid-cols-1 gap-0">
//                                         <CheckboxList items={filterOptions.byThePans} {...checkboxProps('byThePan')} />
//                                     </div>
//                                 </FilterSection>
//                             )}

//                             {/* Dietary Restrictions */}
//                             {filterOptions.dietaryRestrictions.length > 0 && (
//                                 <FilterSection title="Dietary Restrictions" {...sharedFilterProps} onClearThis={() => resetSingleFilter('dietaryRestrictions')}>
//                                     <CheckboxList items={filterOptions.dietaryRestrictions} {...checkboxProps('dietaryRestrictions')} />
//                                 </FilterSection>
//                             )}

//                             {/* Cuisine Type */}
//                             {isVisible('isVisibleSiteCuisineType') && (
//                                 <FilterSection title="Cuisine Type" {...sharedFilterProps} onClearThis={() => resetSingleFilter('cuisineType')}>
//                                     <CheckboxList items={filterOptions.cuisineTypes} {...checkboxProps('cuisineType')} />
//                                 </FilterSection>
//                             )}

//                             {/* Holidays */}
//                             {isVisible('isVisibleSiteHoliday') && (
//                                 <FilterSection
//                                     title="Holidays"
//                                     {...sharedFilterProps}
//                                     onClearThis={() => resetSingleFilter('holiday')}
//                                     open={!!holidayURLParam}
//                                 >
//                                     <CheckboxList items={filterOptions.holidays} {...checkboxProps('holiday')} />
//                                 </FilterSection>
//                             )}

//                             {/* Price Range */}
//                             {isVisible('isVisibleSitePayments') && (
//                                 <FilterSection title="Price Range" {...sharedFilterProps} onClearThis={resetPriceRange}>
//                                     <div className="p-2 flex flex-col gap-0.5">
//                                         <Range
//                                             step={intPriceRangeStep}
//                                             min={priceRange.low}
//                                             max={priceRange.high}
//                                             values={priceState.values}
//                                             onChange={(values) => setPriceState({ values })}
//                                             renderTrack={({ props, children }) => (
//                                                 <div {...props} className="w-full h-[6px] bg-slate-500 rounded-full cursor-pointer">
//                                                     {children}
//                                                 </div>
//                                             )}
//                                             renderThumb={({ props }) => (
//                                                 <div className="w-[15px] h-[15px] bg-[#059473] rounded-full" {...props} />
//                                             )}
//                                         />
//                                         <span className="font-bold text-lg" style={{ color: sellerPrimaryColor1 }}>
//                                             ${Math.floor(priceState.values[0])} – ${Math.floor(priceState.values[1])}
//                                         </span>
//                                     </div>
//                                 </FilterSection>
//                             )}

//                             {/* Rating */}
//                             {isVisible('isVisibleSiteRating') && (
//                                 <FilterSection title="Rating" {...sharedFilterProps} onClearThis={() => resetSingleFilter('rating')}>
//                                     <div className="py-3 flex flex-col gap-3">
//                                         {[5, 4, 3, 2, 1].map((n) => (
//                                             <div
//                                                 key={n}
//                                                 onClick={() => queryFilter('rating', n, true)}
//                                                 className="text-orange-500 flex justify-start items-center gap-2 text-xl cursor-pointer"
//                                             >
//                                                 {Array.from({ length: 5 }, (_, i) =>
//                                                     i < n ? <AiFillStar key={i} /> : <CiStar key={i} />
//                                                 )}
//                                             </div>
//                                         ))}
//                                     </div>
//                                 </FilterSection>
//                             )}

//                             {/* Action buttons */}
//                             <button onClick={resetAllFilters}
//                                 className="font-semibold flex rounded-lg w-full py-1 px-4 text-white"
//                                 style={{ backgroundColor: sellerPrimaryColor1 }}>
//                                 <MdFilterListOff className="mr-1 mt-0.5" /> Clear All Filters
//                             </button>
//                             <button onClick={() => goTo('/customerDashboard/sampleMenus')}
//                                 className="mt-2 font-semibold flex rounded-lg w-full py-1 px-4 text-white"
//                                 style={{ backgroundColor: sellerPrimaryColor1 }}>
//                                 <MdOutlineRestaurantMenu className="mr-1 mt-1" /> Sample Menus
//                             </button>
//                             <button onClick={() => goTo('/customerDashboard/sellerPackages')}
//                                 className="mt-2 font-semibold flex rounded-lg w-full py-1 px-4 text-white"
//                                 style={{ backgroundColor: sellerPrimaryColor1 }}>
//                                 <FaGift className="mr-1 mt-1" /> Packages
//                             </button>

//                             {isVisible('isVisibleSiteProductsUnderFilter') && (
//                                 <div className="py-3 flex gap-4 md:hidden border-2 rounded-lg mt-2 justify-center items-center"
//                                     style={{ borderColor: sellerPrimaryColor1 }}>
//                                     <Products title={`Latest ${sellerProductPluralTerm}`} products={latest_product} parentPage="Shops" />
//                                 </div>
//                             )}
//                         </div>

//                         {/* ── Product Grid ── */}
//                         <div className="w-9/12 md-lg:w-8/12 md:w-full">
//                             <div className="pl-2 md:pl-0">
//                                 <div className="py-1 px-2 mb-4 flex justify-between items-start border"
//                                     style={{ borderColor: sellerPrimaryColor1, backgroundColor: sellerSecondaryColor1 }}>

//                                     {/* Active filter summary */}
//                                     <div className="flex gap-1 justify-center items-start md-lg:hidden">
//                                         <div className="p-1 text-lg font-medium" style={{ color: sellerPrimaryColor1 }}>
//                                             <span>{totalProduct} {sellerProductTerm}{totalProduct !== 1 ? 's' : ''}</span>
//                                             <span className="ml-1 text-[14px] font-normal" style={{ color: sellerPrimaryColor1 }}>
//                                                 {filters.category && `Category: ${filters.category}; `}
//                                                 {filters.mainIngredient && `${sellerMainIngredientTerm}: ${filters.mainIngredient}; `}
//                                                 {filters.FMP && `FMP: ${filters.FMP}; `}
//                                                 {filters.cookingMethod && `Cooking Method: ${filters.cookingMethod}; `}
//                                                 {filters.byThePan && `By The Pan: ${filters.byThePan}; `}
//                                                 {filters.dietaryRestrictions && `Dietary Restrictions: ${filters.dietaryRestrictions}; `}
//                                                 {filters.cuisineType && `Cuisine: ${filters.cuisineType}; `}
//                                                 {filters.holiday && `Holiday: ${filters.holiday}; `}
//                                                 {filters.rating && `Rating: ${filters.rating} Star`}
//                                             </span>
//                                         </div>
//                                     </div>

//                                     <div className="flex justify-center items-center gap-2">
//                                         {isVisible('isVisibleSitePayments') && (
//                                             <select onChange={(e) => setSortPrice(e.target.value)}
//                                                 className="p-1 border outline-0 font-semibold"
//                                                 style={{ color: sellerPrimaryColor1 }}>
//                                                 <option value="">Sort By</option>
//                                                 <option value="low-to-high">Low to High Price</option>
//                                                 <option value="high-to-low">High to Low Price</option>
//                                             </select>
//                                         )}
//                                         <div className="flex mt-0.5 mb-0.5 gap-1 justify-center items-start md-lg:hidden">
//                                             <div onClick={() => setStyles('grid')}
//                                                 className={`p-2 cursor-pointer rounded-lg border ${styles === 'grid' ? 'bg-slate-300' : 'bg-white hover:bg-slate-300'}`}
//                                                 style={{ borderColor: sellerPrimaryColor1 }}>
//                                                 <BsFillGridFill style={{ color: sellerPrimaryColor1 }} />
//                                             </div>
//                                             <div onClick={() => setStyles('list')}
//                                                 className={`p-2 cursor-pointer rounded-lg border ${styles === 'list' ? 'bg-slate-300' : 'bg-white hover:bg-slate-300'}`}
//                                                 style={{ borderColor: sellerPrimaryColor1 }}>
//                                                 <FaThList style={{ color: sellerPrimaryColor1 }} />
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="pb-8">
//                                     <ShopProductGridListView products={products} styles={styles} />
//                                 </div>

//                                 {totalProduct > parPage && (
//                                     <Pagination
//                                         pageNumber={pageNumber}
//                                         setPageNumber={setPageNumber}
//                                         totalItems={totalProduct}
//                                         parPage={parPage}
//                                         showItem={Math.floor(totalProduct / parPage)}
//                                     />
//                                 )}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//             <Footer />
//         </div>
//     );
// };

// export default Shops;



// my original code
// import React, { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link, Outlet, useNavigate, useLocation, useParams } from 'react-router-dom';

// import { IoIosArrowForward } from "react-icons/io";
// import { Range } from 'react-range';
// import {AiFillStar} from 'react-icons/ai'
// import {CiStar} from 'react-icons/ci'
// import {BsFillGridFill} from 'react-icons/bs'
// import {FaThList, FaCaretDown, FaCaretUp, FaGift } from "react-icons/fa";
// import { MdOutlineRestaurantMenu, MdFilterListOff } from "react-icons/md";
// import { IoFilterOutline, IoFilterSharp } from "react-icons/io5";
// import { GoGift } from "react-icons/go";
// import { HiChevronUpDown, HiChevronUp, HiChevronDown  } from "react-icons/hi2";

// import { price_range_product, query_products } from '../store/reducers/homeReducer';

// import Products from '../components/products/Products';
// import ShopProductGridListView from '../components/products/ShopProductGridListView';
// import Pagination from '../components/Pagination';
// import Header from '../components/Header';
// import Footer from '../components/Footer';
// import ShopBanner from '../components/ShopBanner';

// //import CollapsiblePanel from '../components/CollapsiblePanel';
// //create react collapsible panel as a componet

// //npm install react-collapsible --save
// import Collapsible from 'react-collapsible';

// //https://www.npmjs.com/package/react-collapsible
// //create tailwind style for https://www.npmjs.com/package/react-collapsible
                                
// //import toast from 'react-hot-toast';
// import config from '../config';
// import { Elements } from '@stripe/react-stripe-js';

// const Shops = () => {
//     const sellerFrontEndURL = config.STR_FRONTEND_URL 
//     const intPriceRangeStep = config.INT_FRONTEND_PRICE_RANGE_STEP  //error fix range

//     const {categorys, mainIngredients, allSiteProducts, products, priceRange, latest_product, 
//         totalProduct, parPage} = useSelector(state => state.home)
//     //console.log('priceRange in Shops.jsx', priceRange)

//     const { seller } = useSelector(state => state.seller)
//     const { userInfo } = useSelector(state => state.auth)

//     const sellerId = seller?._id 
//     const sellerPrimaryColor1 = seller?.frontEndPrimaryColor1
//     const sellerPrimaryColor2 =  seller?.frontEndPrimaryColor2
//     const sellerSecondaryColor1 = seller?.frontEndSecondaryColor1
//     const sellerMainIngredientTerm = seller?.mainIngredientTerm
//     const sellerMainIngredientPluralTerm = seller?.mainIngredientPluralTerm
//     const sellerProductTerm = seller?.productTerm
//     const sellerProductPluralTerm = seller?.productPluralTerm
    
//     const sellerBoolShowSitePayments = seller?.isVisibleSitePayments === 'Show' ? true : false
//     const sellerBoolShowSiteRating = seller?.isVisibleSiteRating === 'Show' ? true : false
//     const sellerBoolShowSiteCookingMethods = seller?.isVisibleSiteCookingMethods === 'Show' ? true : false
//     const sellerBoolShowSiteProductsUnderFilter = seller?.isVisibleSiteProductsUnderFilter === 'Show' ? true : false
//     const sellerBoolShowSiteCuisineType = seller?.isVisibleSiteCuisineType === 'Show' ? true : false
//     const sellerBoolShowSiteHoliday = seller?.isVisibleSiteHoliday === 'Show' ? true : false
    
//     const [filter, setFilter] = useState(true)
//     const filterItemTextSize = '12px'
//     const navigate = useNavigate()
//     const dispatch = useDispatch()

//     const {holidayURLParam} = useParams()
    
//     const [data, setData] = useState(null);
//     const [isLoading, setIsLoading] = useState(true)

//     // console.log(allSiteProducts)//not sorted by name
//     // console.log(products)//sorted by name
//     useEffect(() => {
//         dispatch(price_range_product(sellerFrontEndURL))
//     },[sellerFrontEndURL])
//     //console.log(priceRange)  && holidayURLParam === 'Passover'
    
//     useEffect(() => {
//         if (holidayURLParam !== undefined && typeof holidayURLParam === 'string' && holidayURLParam.length > 0) {
//             setHoliday(holidayURLParam)
//         }
//     },[])//holidayURLParam
    
//     const priceRangeMinPrice = priceRange.low || 0; 
//     const priceRangeMaxPrice = priceRange.high || 1; //25 100;
//     const [state, setState] = useState({values: [priceRange.low, priceRange.high]})
    
//     useEffect(() => { 
//         setState({
//             values: [priceRange.low, priceRange.high]
//         })
//     },[priceRange])
//     //let priceRangeMaxPrice = priceRange.high < 100 ? priceRange.high : 100
        
//     //console.log('priceRange.high ', priceRange.high, 'priceRangeMaxPrice ', priceRangeMaxPrice)
//     //console.log('seller\n', seller)
    
//     const [arrCategories, setArrCategories] = useState([]);
//     const addToCategories = (val) => {
//         if (val){
//             //console.log(val)
//             if (!arrCategories.includes(val)) {
//                 setArrCategories([...arrCategories, val])
//             }
//         }
//     }

//     const [arrMainIngredients, setArrMainIngredients] = useState([]);
//     const addToMainIngredients = (val) => {
//         if (val){
//             //console.log(val)
//             if (!arrMainIngredients.includes(val)) {
//                 setArrMainIngredients([...arrMainIngredients, val])
//             }
//         }
//     }

//     const [arrFMP, setArrFmp] = useState([]);
//     const addToFMP = (val) => {
//         if (val){
//             //console.log(val)
//             if (!arrFMP.includes(val)) {
//                 setArrFmp([...arrFMP, val])
//             }
//         }
//     }

//     const [arrCookingMethods, setArrCookingMethods] = useState([]);
//     const addToCookingMethods = (val) => {
//         if (val){
//             //console.log(val)
//             if (!arrCookingMethods.includes(val)) {
//                 setArrCookingMethods([...arrCookingMethods, val])
//             }
//         }      
//     }

//     const [arrByThePans, setArrByThePans] = useState([]);
//     const addToByThePans = (val) => {
//         if (val){
//             //console.log(val)
//             if (!arrByThePans.includes(val)) {
//                 if (val !== 'NoPan') {
//                     setArrByThePans([...arrByThePans, val])
//                 }
//                 //setArrByThePans([...arrByThePans, val])
//             }
//         }      
//     }

//     //dietaryRestrictions
//     const [arrDietaryRestrictionss, setArrDietaryRestrictionss] = useState([]);
//     const addToDietaryRestrictionss = (val) => {
//         if (val){
//             //console.log(val)
//             if (!arrDietaryRestrictionss.includes(val)) {
//                 if (val !== 'None') {
//                     setArrDietaryRestrictionss([...arrDietaryRestrictionss, val])
//                 }
//             }
//         }      
//     }

//     const [arrCuisineTypes, setArrCuisineTypes] = useState([]);
//     const addToCuisineTypes = (val) => {
//         if (val){
//             //console.log(val)
//             if (!arrCuisineTypes.includes(val)) {
//                 setArrCuisineTypes([...arrCuisineTypes, val])
//             }
//         }      
//     }
//     //console.log(arrCuisineTypes)

//     const [arrHolidays, setArrHolidays] = useState([]);
//     const addToHolidays = (val) => {
//         if (val){
//             //console.log(val)
//             if (!arrHolidays.includes(val)) {
//                 if (val !== 'None') {
//                     setArrHolidays([...arrHolidays, val])
//                 }
//             }
//         }      
//     }
//     //console.log(arrHolidays)

//     const [rating, setRating] = useState('')
//     const [styles, setStyles] = useState('grid')

//     const [pageNumber, setPageNumber] = useState(1)
//     const [sortPrice, setSortPrice] = useState('')

//     const [category, setCategory] = useState('')
//     const queryCategory = (e, value) => {
//         if (e.target.checked) {
//             setCategory(value)
//         } else {
//             setCategory('')
//         }
//     }

//     const [mainIngredient, setMainIngredient] = useState('')
//     const queryMainIngredient = (e, value) => {
//         if (e.target.checked) {
//             setMainIngredient(value)
//         } else {
//             setMainIngredient('')
//         }
//     }

//     const [FMP, setFmp] = useState('')
//     const queryFMP =  (e, value) => {
//         //alert(value)
//         if (e.target.checked) {
//             setFmp(value)
//         } else {
//             setFmp('')
//         }
//         //alert(FMP)
//     }

//     const [cookingMethod, setCookingMethod] = useState('')
//     const queryCookingMethod =  (e, value) => {
//         //alert(value)
//         if (e.target.checked) {
//             setCookingMethod(value)
//         } else {
//             setCookingMethod('')
//         }
//         //alert(cookingMethod)
//     }

//     const [byThePan, setByThePan] = useState('')
//     const queryByThePan =  (e, value) => {
//     //     //alert(value)
//         if (e.target.checked) {
//             setByThePan(value)
//         } else {
//             setByThePan('')
//         }
//     //     //alert(cookingMethod)
//     }

//     const [dietaryRestrictions, setDietaryRestrictions] = useState('')
//     const queryDietaryRestrictions =  (e, value) => {
//         //alert(value)
//          if (e.target.checked) {
//              setDietaryRestrictions(value)
//          } else {
//              setDietaryRestrictions('')
//          }
//         //alert(dietaryRestrictions)
//     }

//     const [cuisineType, setCuisineType] = useState('')
//     const queryCuisineType =  (e, value) => {
//         //alert(value)
//          if (e.target.checked) {
//              setCuisineType(value)
//          } else {
//              setCuisineType('')
//          }
//         //alert(dietaryRestrictions)
//     }

//     const [holiday, setHoliday] = useState('')
//     const queryHoliday =  (e, value) => {
//         //alert(value)
//          if (e.target.checked) {
//              setHoliday(value)
//          } else {
//              setHoliday('')
//          }
//         //alert(dietaryRestrictions)
//     }   

//     useEffect(() => { 
//         dispatch(
//             query_products({
//                 webSiteOrigin: sellerFrontEndURL,
//                 low: state.values[0],
//                 high: state.values[1],
//                 category,
//                 mainIngredient,
//                 FMP,
//                 cookingMethod,
//                 byThePan,
//                 dietaryRestrictions,
//                 cuisineType,
//                 holiday,
//                 rating,
//                 sortPrice,
//                 pageNumber
//             })
//          )
//     },[sellerFrontEndURL, state.values[0], state.values[1], category, mainIngredient, FMP, cookingMethod, byThePan, dietaryRestrictions, cuisineType, holiday, rating, sortPrice, pageNumber])
    
//     const resetFilter = () => {
//         setCategory('')
//         setMainIngredient('')
//         setFmp('')
//         setCookingMethod('')
//         setByThePan('')
//         setDietaryRestrictions('')
//         setCuisineType('')
//         setHoliday('')
//         setRating('')
//         dispatch(
//             query_products({
//                 webSiteOrigin: sellerFrontEndURL, low: state.values[0], high: state.values[1],
//                 category: '', mainIngredient: '', FMP:'', cookingMethod:'', byThePan:'',
//                 dietaryRestrictions:'', cuisineType:'', holiday: '', rating: '',
//                 sortPrice, pageNumber
//             }))
//         dispatch(price_range_product(sellerFrontEndURL))
//     }
    
//     const resetCategoryFilter = () => {
//         setCategory('')
//         dispatch(
//             query_products({
//                 webSiteOrigin: sellerFrontEndURL, low: state.values[0], high: state.values[1],
//                 category: '', mainIngredient: '', FMP:'', cookingMethod:'', byThePan:'',
//                 dietaryRestrictions:'', cuisineType:'', holiday: '', rating: '',
//                 sortPrice, pageNumber
//             }))
//         dispatch(price_range_product(sellerFrontEndURL))
//     }
    
//     const resetMainIngredientFilter = () => {
//         setMainIngredient('')
//         dispatch(
//             query_products({
//                 webSiteOrigin: sellerFrontEndURL, low: state.values[0], high: state.values[1],
//                 category: '', mainIngredient: '', FMP:'', cookingMethod:'', byThePan:'',
//                 dietaryRestrictions:'', cuisineType:'', holiday: '', rating: '',
//                 sortPrice, pageNumber
//             }))
//         dispatch(price_range_product(sellerFrontEndURL))
//     }
    
//     const resetFMPFilter = () => {
//         setFmp('')
//         dispatch(
//             query_products({
//                 webSiteOrigin: sellerFrontEndURL, low: state.values[0], high: state.values[1],
//                 category: '', mainIngredient: '', FMP:'', cookingMethod:'', byThePan:'',
//                 dietaryRestrictions:'', cuisineType:'', holiday: '', rating: '',
//                 sortPrice, pageNumber
//             }))
//         dispatch(price_range_product(sellerFrontEndURL))
//     }

//     const resetCookingMethodFilter = () => {
//         setCookingMethod('')
//         dispatch(
//             query_products({
//                 webSiteOrigin: sellerFrontEndURL, low: state.values[0], high: state.values[1],
//                 category: '', mainIngredient: '', FMP:'', cookingMethod:'', byThePan:'',
//                 dietaryRestrictions:'', cuisineType:'', holiday: '', rating: '',
//                 sortPrice, pageNumber
//             }))
//         dispatch(price_range_product(sellerFrontEndURL))
//     }
    
//     const resetByThePanFilter = () => {
//         setByThePan('')
//         dispatch(
//             query_products({
//                 webSiteOrigin: sellerFrontEndURL, low: state.values[0], high: state.values[1],
//                 category: '', mainIngredient: '', FMP:'', cookingMethod:'', byThePan:'',
//                 dietaryRestrictions:'', cuisineType:'', holiday: '', rating: '',
//                 sortPrice, pageNumber
//             }))
//         dispatch(price_range_product(sellerFrontEndURL))
//     }
    
//     const resetDietaryRestrictionsFilter = () => {
//         setDietaryRestrictions('')
//         dispatch(
//             query_products({
//                 webSiteOrigin: sellerFrontEndURL, low: state.values[0], high: state.values[1],
//                 category: '', mainIngredient: '', FMP:'', cookingMethod:'', byThePan:'',
//                 dietaryRestrictions:'', cuisineType:'', holiday: '', rating: '',
//                 sortPrice, pageNumber
//             }))
//         dispatch(price_range_product(sellerFrontEndURL))
//     }
    
//     const resetCuisineTypeFilter = () => {
//         setCuisineType('')
//         dispatch(
//             query_products({
//                 webSiteOrigin: sellerFrontEndURL, low: state.values[0], high: state.values[1],
//                 category: '', mainIngredient: '', FMP:'', cookingMethod:'', byThePan:'',
//                 dietaryRestrictions:'', cuisineType:'', holiday: '', rating: '',
//                 sortPrice, pageNumber
//             }))
//         dispatch(price_range_product(sellerFrontEndURL))
//     }
    
//     const resetHolidayFilter = () => {
//         setHoliday('')
//         dispatch(
//             query_products({
//                 webSiteOrigin: sellerFrontEndURL, low: state.values[0], high: state.values[1],
//                 category: '', mainIngredient: '', FMP:'', cookingMethod:'', byThePan:'',
//                 dietaryRestrictions:'', cuisineType:'', holiday: '', rating: '',
//                 sortPrice, pageNumber
//             }))
//         dispatch(price_range_product(sellerFrontEndURL))
//     }

//     const resetPriceRangeFilter = () => {
//         // setCategory('')
//         // setMainIngredient('')
//         // setFmp('')
//         // setCookingMethod('')
//         // setByThePan('')
//         // setDietaryRestrictions('')
//         // setCuisineType('')
//         // setHoliday('')
//         // setRating('')
//         // dispatch(
//         //     query_products({
//         //         webSiteOrigin: sellerFrontEndURL, low: state.values[0], high: state.values[1],
//         //         category: '', mainIngredient: '', FMP:'', cookingMethod:'', byThePan:'',
//         //         dietaryRestrictions:'', cuisineType:'', holiday: '', rating: '',
//         //         sortPrice, pageNumber
//         //     }))
//         dispatch(price_range_product(sellerFrontEndURL))
//     }
    
    
//     const resetRatingFilter = () => {
//         setRating('')
//         dispatch(
//             query_products({
//                 webSiteOrigin: sellerFrontEndURL, low: state.values[0], high: state.values[1],
//                 category: '', mainIngredient: '', FMP:'', cookingMethod:'', byThePan:'',
//                 dietaryRestrictions:'', cuisineType:'', holiday: '', rating: '',
//                 sortPrice, pageNumber
//             }))
//         dispatch(price_range_product(sellerFrontEndURL))
//     }

//     const goToSampleMenus = () => {
//         if (userInfo) {
//             navigate('/customerDashboard/sampleMenus')
//         } else {
//             navigate('/login')
//         }
//     }

//     const goToSellerPackages = () => {
//         if (userInfo) {
//             navigate('/customerDashboard/sellerPackages')
//         } else {
//             navigate('/login')
//         }
//     }
//     //http://localhost:3000/customerDashboard/sellerPackages


//     // const redirect_cart_page = () => {
//     //     if (userInfo) {
//     //         navigate('/cart')
//     //     } else {
//     //         navigate('/login')
//     //     }
//     // }
//     //const arrCollapsibleTitles = ['Category', 'Main Ingredient', 'FMP', 'Cooking Method', 'By The Pan', 'Dietary Restrictions', 'Cuisine Type', 'Holiday', 'Rating'] // Define the array of CollapsibleTitle
//     const triggerClosed = (title) => {
//         return (
//             <div className="trigger-wrapper flex items-center justify-between w-full rounded-md transition-all cursor-pointer"
//                 style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>            
//                 <span className="font-semibold pl-1 text-[15px] ">{title}</span>            
//                 <HiChevronDown size={24} className="font-bold arrow-icon" />
//             </div>
//         )
//     }
    
//     // Define the "Open" state 
//     const triggerOpen = (title) => {
//         return (
//             <div className="trigger-wrapper flex items-center justify-between w-full rounded-t-md transition-all cursor-pointer"
//                 style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>    
//                 <span className="font-semibold pl-1 text-[15px]">{title}</span>
//                 <HiChevronUp size={24} className="font-bold arrow-icon" />
//             </div>
//         )
//     }

//     return (
//         <div>
//             <style>
//                 {`
//                     .Collapsible__contentInner {
//                         background-color: ${sellerSecondaryColor1}; 
//                     }
//                     .Collapsible__contentOuter {
//                         cursor: default;
//                     }
//                     .trigger-wrapper {
//                         display: flex;
//                         justify-content: space-between;
//                         align-items: center;
//                         cursor: pointer;
//                         padding: 0px;
//                         background: #f0f0f0;
//                     }
//                     .arrow-icon {
//                         transition: transform 0.3s ease-in-out;
//                     }
//                     .Collapsible__trigger.is-open .arrow-icon {
//                         /*transform: rotate(180deg);*/
//                     }
//                 `}
//             </style>
//             <Header/>
//             <section className='py-2'>
//                 <div className='w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto'>
//                     <div className='mb-4'>
//                         <ShopBanner homePage={'Home'} homeLink={'/'} currentPageTop={'All ' + sellerProductPluralTerm} currentPageTopLink={''} 
//                             currentPageBottom1={'All ' + sellerProductPluralTerm} currentPageBottomLink1={''} 
//                             currentPageBottom2={''} currentPageBottomLink2={''} />
//                     </div>
//                     <div className={` md:block hidden ${!filter ? 'mb-6' : 'mb-0'} `}>
//                         <button onClick={() => setFilter(!filter)} 
//                             className='flex items-center justify-center text-center rounded-lg w-full py-2 px-3 text-white'  
//                             style={{backgroundColor:sellerPrimaryColor1}}>
//                             <IoFilterSharp className='mr-1' />Filter {sellerProductPluralTerm} 
//                             <FaCaretDown className={` ${filter ? '' : 'hidden'} text-2xl ml-1`} /> 
//                             <FaCaretUp className={` ${!filter ? '' : 'hidden'} text-2xl ml-1`} />
//                         </button> 
//                     </div>
//                     <div className='w-full border-none flex flex-wrap'>
//                         <div className={`border-none border-gray-600 w-3/12 md-lg:w-4/12 md:w-full pr-8 
//                             ${filter ? 'md:h-0 md:overflow-hidden md:mb-6' : 'md:h-auto md:overflow-auto md:mb-0' } `}>
//                             <div className={` ${filter ? 'flex text-xl font-bold mb-3' : 'hidden'}  `} 
//                                 style={{color:sellerPrimaryColor1}}>
//                                 <IoFilterSharp className='mr-1 mt-1' /> Filter {sellerProductPluralTerm}
//                             </div>
//                             <div className={` p-1 border rounded-md mb-2`}
//                                 style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                                 <Collapsible 
//                                     trigger={triggerClosed("Categories")} 
//                                     triggerWhenOpen={triggerOpen("Categories")}
//                                     transitionTime={300}
//                                     easing="ease-in-out"
//                                     contentOuterClassName="overflow-hidden"
//                                     open={false}>
//                                     <div className='grid grid-cols-2 gap-1'>
//                                         {
//                                             // categorys.map((c,i) => 
//                                             //     <div key={i} 
//                                             //         className={` ${c.webSiteOrigin === sellerFrontendURL ? 'border-none w-[124px] flex justify-start items-center gap-2 py-1' : 'hidden'}` } >
//                                             //         <input type="checkbox" id={c.name} checked={category === c.name ? true : false} 
//                                             //             onChange={(e)=>queryCategory(e,c.name)} />
//                                             //         <label className='block cursor-pointer text-sm' 
//                                             //             style={{color:sellerPrimaryColor1}} htmlFor={c.name}>{c.name}</label>
//                                             //     </div>
//                                             // )
//                                             allSiteProducts.map((d,i) => 
//                                                 {
//                                                     addToCategories(d.category)
//                                                     addToMainIngredients(d.mainIngredient)
//                                                     addToFMP(d.FMP)
//                                                     addToCookingMethods(d.cookingMethod)
//                                                     addToByThePans(d.byThePan)
//                                                     addToDietaryRestrictionss(d.dietaryRestrictions)
//                                                     addToCuisineTypes(d.cuisineType)
//                                                     addToHolidays(d.holiday)
//                                                 }
//                                             )
//                                         }
//                                         {
//                                             arrCategories.sort().map((c,i) =>
//                                                 <div key={i} className='ml-0.5 p-0.5 w-full border-none flex 
//                                                     justify-start items-center gap-1 py-1'>
//                                                     <div className='border-none align-top mr-1'>
//                                                         <input type="checkbox" id={c} className='border-none' 
//                                                             style={{accentColor:sellerPrimaryColor1}} 
//                                                             checked={category === c ? true : false} 
//                                                             onChange={(e)=>queryCategory(e,c)} />
//                                                     </div>
//                                                     <label className='break-words border-none cursor-pointer' 
//                                                         style={{color:sellerPrimaryColor1, fontSize: filterItemTextSize}} htmlFor={c}>{c}
//                                                     </label>
//                                                 </div>
//                                             )          
//                                         }
//                                     </div>
//                                     <div className='w-full flex justify-center items-center mt-0.5' >
//                                         <button onClick={resetCategoryFilter} 
//                                             className='w-[50%] flex text-nowrap items-center justify-center text-center m-0.5 rounded-md text-[11px] p-0.5 text-white' 
//                                             style={{backgroundColor:sellerPrimaryColor1}}>
//                                             <MdFilterListOff size={12} className='mr-1' />Clear This Filter
//                                         </button>
//                                         <button onClick={resetFilter} 
//                                             className='w-[50%] flex text-nowrap items-center justify-center m-0.5 text-center rounded-md text-[11px] p-0.5 text-white' 
//                                             style={{backgroundColor:sellerPrimaryColor1}}>
//                                             <MdFilterListOff size={12} className='mr-1' />Clear All Filters
//                                         </button> 
//                                     </div>
//                                 </Collapsible>
//                             </div>
//                             <div className={` p-1 border rounded-md mb-2`}
//                                 style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                                 <Collapsible
//                                     trigger={triggerClosed(sellerMainIngredientPluralTerm)} 
//                                     triggerWhenOpen={triggerOpen(sellerMainIngredientPluralTerm)}
//                                     transitionTime={300}
//                                     easing="ease-in-out"
//                                     contentOuterClassName="overflow-hidden"
//                                     open={false}>
//                                     <div className='grid grid-cols-2 gap-1'>
//                                     {
//                                         // mainIngredients.map((c,i) => 
//                                         //     <div key={i} 
//                                         //         className={` ${c.webSiteOrigin === sellerFrontendURL ? 'w-[124px] flex justify-start items-center gap-2 py-1' : 'hidden'}` } >
//                                         //         <input type="checkbox" id={c.name} checked={mainIngredient === c.name ? true : false} 
//                                         //             onChange={(e)=>queryMainIngredient(e,c.name)} />
//                                         //         <label className='block cursor-pointer text-sm' 
//                                         //             style={{color:sellerPrimaryColor1}} htmlFor={c.name}>{c.name}</label>
//                                         //     </div>
//                                         // )
//                                         arrMainIngredients.sort().map((c,i) =>
//                                             <div key={i} className='ml-0.5 p-0.5 w-full border-none flex 
//                                                 justify-start items-center gap-1 py-1'>
//                                                 <div className='border-none align-top'>
//                                                     <input type="checkbox" id={c} className='border-none'
//                                                         style={{accentColor:sellerPrimaryColor1}}
//                                                         checked={mainIngredient === c ? true : false} 
//                                                         onChange={(e)=>queryMainIngredient(e,c)} />
//                                                 </div>
//                                                 <label className='block border-none cursor-pointer' 
//                                                     style={{color:sellerPrimaryColor1, fontSize: filterItemTextSize}} htmlFor={c}>{c}
//                                                 </label>
//                                             </div>
//                                         )          
//                                     }
//                                     </div>
//                                     <div className='w-full flex justify-center items-center mt-0.5' >
//                                         <button onClick={resetMainIngredientFilter} 
//                                             className='w-[50%] flex text-nowrap items-center justify-center m-0.5 text-center rounded-md text-[11px] p-0.5 text-white' 
//                                             style={{backgroundColor:sellerPrimaryColor1}}>
//                                             <MdFilterListOff size={12} className='mr-1' />Clear This Filter
//                                         </button>
//                                         <button onClick={resetFilter} 
//                                             className='w-[50%] flex text-nowrap items-center justify-center m-0.5 text-center rounded-md text-[11px] p-0.5 text-white' 
//                                             style={{backgroundColor:sellerPrimaryColor1}}>
//                                             <MdFilterListOff size={12} className='mr-1' />Clear All Filters
//                                         </button> 
//                                     </div>
//                                 </Collapsible>
//                             </div>
//                             <div className={` p-1 border rounded-md mb-2`}
//                                 style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                                 <Collapsible 
//                                     trigger={triggerClosed("Fleishig / Meat / Parve")} 
//                                     triggerWhenOpen={triggerOpen("Fleishig / Meat / Parve")}
//                                     transitionTime={300}
//                                     easing="ease-in-out"
//                                     contentOuterClassName="overflow-hidden"
//                                     open={false}>
//                                     <div className='grid grid-cols-2 gap-0'>
//                                     {
//                                         arrFMP.sort().map((c,i) =>
//                                             <div key={i} className='ml-0.5 p-0.5 w-full border-none flex 
//                                                 justify-start items-center gap-1 py-1'>
//                                                 <div className='border-none align-top'>
//                                                     <input type="checkbox" id={c} className='border-none'
//                                                         style={{accentColor:sellerPrimaryColor1}}
//                                                         checked={FMP === c ? true : false} 
//                                                         onChange={(e)=>queryFMP(e,c)} />
//                                                 </div>
//                                                 <label className='block border-none cursor-pointer' 
//                                                     style={{color:sellerPrimaryColor1, fontSize: filterItemTextSize}} htmlFor={c}>{c}
//                                                 </label>
//                                             </div>
//                                         )                                
//                                     } 
//                                     </div>
//                                     <div className='w-full flex justify-center items-center mt-0.5' >
//                                         <button onClick={resetFMPFilter} 
//                                             className='w-[50%] flex text-nowrap items-center justify-center m-0.5 text-center rounded-md text-[11px] p-0.5 text-white' 
//                                             style={{backgroundColor:sellerPrimaryColor1}}>
//                                             <MdFilterListOff size={12} className='mr-1' />Clear This Filter
//                                         </button>
//                                         <button onClick={resetFilter} 
//                                             className='w-[50%] flex text-nowrap items-center justify-center m-0.5 text-center rounded-md text-[11px] p-0.5 text-white' 
//                                             style={{backgroundColor:sellerPrimaryColor1}}>
//                                             <MdFilterListOff size={12} className='mr-1' />Clear All Filters
//                                         </button> 
//                                     </div>
//                                 </Collapsible>
//                             </div>
//                             <div className={` ${sellerBoolShowSiteCookingMethods ? '' : 'hidden'} p-1 border rounded-md mb-2`}
//                                 style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                                 <Collapsible 
//                                     trigger={triggerClosed("Cooking Method")} 
//                                     triggerWhenOpen={triggerOpen("Cooking Method")}
//                                     transitionTime={300}
//                                     easing="ease-in-out"
//                                     contentOuterClassName="overflow-hidden"
//                                     open={false}>
//                                     <div className='grid grid-cols-2 gap-0'>
//                                     {
//                                         arrCookingMethods.sort().map((c,i) =>
//                                             <div key={i} className='ml-0.5 p-0.5 w-full border-none flex 
//                                                 justify-start items-center gap-1 py-1'>
//                                                 <div className='border-none align-top'>
//                                                     <input type="checkbox" id={c} className='border-none'
//                                                         style={{accentColor:sellerPrimaryColor1 , borderColor:sellerPrimaryColor1}}
//                                                         checked={cookingMethod === c ? true : false} 
//                                                         onChange={(e)=>queryCookingMethod(e,c)} />
//                                                 </div>
//                                                 <label className='block border-none cursor-pointer' 
//                                                     style={{color:sellerPrimaryColor1, fontSize: filterItemTextSize}} htmlFor={c}>{c}
//                                                 </label>
//                                             </div>
//                                         )
//                                     }
//                                     </div>
//                                     <div className='w-full flex justify-center items-center mt-0.5' >
//                                         <button onClick={resetCookingMethodFilter} 
//                                             className='w-[50%] flex text-nowrap items-center justify-center m-0.5 text-center rounded-md text-[11px] p-0.5 text-white' 
//                                             style={{backgroundColor:sellerPrimaryColor1}}>
//                                             <MdFilterListOff size={12} className='mr-1' />Clear This Filter
//                                         </button>
//                                         <button onClick={resetFilter} 
//                                             className='w-[50%] flex text-nowrap items-center justify-center m-0.5 text-center rounded-md text-[11px] p-0.5 text-white' 
//                                             style={{backgroundColor:sellerPrimaryColor1}}>
//                                             <MdFilterListOff size={12} className='mr-1' />Clear All Filters
//                                         </button> 
//                                     </div>
//                                 </Collapsible>
//                             </div>
//                             <div className={` ${arrByThePans.length > 0 ? '' : 'hidden'} p-1 border rounded-md mb-2`}
//                                 style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                                 <Collapsible 
//                                     trigger={triggerClosed("By The Pan")} 
//                                     triggerWhenOpen={triggerOpen("By The Pan")}
//                                     transitionTime={300}
//                                     easing="ease-in-out"
//                                     contentOuterClassName="overflow-hidden"
//                                     open={false}>
//                                     <div className='grid grid-cols-1 gap-0'>
//                                     {
//                                         arrByThePans.sort().map((c,i) =>
//                                             <div key={i} className='ml-0.5 p-0.5 w-full border-none flex 
//                                                 justify-start items-center gap-1 py-1'>
//                                                 <div className='border-none align-top'>
//                                                     <input type="checkbox" id={c} className='border-none'
//                                                         style={{accentColor:sellerPrimaryColor1 , borderColor:sellerPrimaryColor1}}
//                                                         checked={byThePan === c ? true : false} 
//                                                         onChange={(e)=>queryByThePan(e,c)} />
//                                                 </div>
//                                                 <label className='block border-none cursor-pointer' 
//                                                     style={{color:sellerPrimaryColor1, fontSize: filterItemTextSize}} htmlFor={c}>{c}
//                                                 </label>
//                                             </div>
//                                         )
//                                     }
//                                     </div>
//                                     <div className='w-full flex justify-center items-center mt-0.5' >
//                                         <button onClick={resetByThePanFilter} 
//                                             className='w-[50%] flex text-nowrap items-center justify-center m-0.5 text-center rounded-md text-[11px] p-0.5 text-white' 
//                                             style={{backgroundColor:sellerPrimaryColor1}}>
//                                             <MdFilterListOff size={12} className='mr-1' />Clear This Filter
//                                         </button>
//                                         <button onClick={resetFilter} 
//                                             className='w-[50%] flex text-nowrap items-center justify-center m-0.5 text-center rounded-md text-[11px] p-0.5 text-white' 
//                                             style={{backgroundColor:sellerPrimaryColor1}}>
//                                             <MdFilterListOff size={12} className='mr-1' />Clear All Filters
//                                         </button> 
//                                     </div>
//                                 </Collapsible>
//                             </div>
//                             <div className={`  ${arrDietaryRestrictionss.length > 0 ? '' : 'hidden'} p-1 border rounded-md mb-2`}
//                                 style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                                 <Collapsible 
//                                     trigger={triggerClosed("Dietary Restrictions")} 
//                                     triggerWhenOpen={triggerOpen("Dietary Restrictions")}
//                                     transitionTime={300}
//                                     easing="ease-in-out"
//                                     contentOuterClassName="overflow-hidden"
//                                     open={false}>
//                                     <div className='grid grid-cols-2 gap-0'>
//                                     {
//                                         arrDietaryRestrictionss.sort().map((c,i) =>
//                                             <div key={i} className='ml-0.5 p-0.5 w-full border-none flex 
//                                                     justify-start items-center gap-1 py-1'>
//                                                 <div className='border-none align-top'>
//                                                     <input type="checkbox" id={c} className='border-none'
//                                                         style={{accentColor:sellerPrimaryColor1 , borderColor:sellerPrimaryColor1}}
//                                                         checked={dietaryRestrictions === c ? true : false} 
//                                                         onChange={(e)=>queryDietaryRestrictions(e,c)} />
//                                                 </div>
//                                                 <label className='block border-none cursor-pointer' 
//                                                     style={{color:sellerPrimaryColor1, fontSize: filterItemTextSize}} htmlFor={c}>{c}
//                                                 </label>
//                                             </div>
//                                         )
//                                     }
//                                     </div>
//                                     <div className='w-full flex justify-center items-center mt-0.5' >
//                                         <button onClick={resetDietaryRestrictionsFilter} 
//                                             className='w-[50%] flex text-nowrap items-center justify-center m-0.5 text-center rounded-md text-[11px] p-0.5 text-white' 
//                                             style={{backgroundColor:sellerPrimaryColor1}}>
//                                             <MdFilterListOff size={12} className='mr-1' />Clear This Filter
//                                         </button>
//                                         <button onClick={resetFilter} 
//                                             className='w-[50%] flex text-nowrap items-center justify-center m-0.5 text-center rounded-md text-[11px] p-0.5 text-white' 
//                                             style={{backgroundColor:sellerPrimaryColor1}}>
//                                             <MdFilterListOff size={12} className='mr-1' />Clear All Filters
//                                         </button> 
//                                     </div>     
//                                 </Collapsible>
//                             </div>
//                             {
//                                 //&& arrCuisineTypes.length > 1
//                             }
//                             <div className={` ${sellerBoolShowSiteCuisineType  ? '' : 'hidden'} p-1 border rounded-md mb-2 `}
//                                 style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                                 <Collapsible 
//                                     trigger={triggerClosed("Cuisine Type")} 
//                                     triggerWhenOpen={triggerOpen("Cuisine Type")}
//                                     transitionTime={300}
//                                     easing="ease-in-out"
//                                     contentOuterClassName="overflow-hidden"
//                                     open={false}>
//                                     <div className='grid grid-cols-2 gap-0'>
//                                     {
//                                         arrCuisineTypes.sort().map((c,i) =>
//                                             <div key={i} className='ml-0.5 p-0.5 w-full border-none flex 
//                                                     justify-start items-center gap-1 py-1'>
//                                                 <div className='border-none align-top'>
//                                                     <input type="checkbox" id={c} className='border-none'
//                                                         style={{accentColor:sellerPrimaryColor1 , borderColor:sellerPrimaryColor1}}
//                                                         checked={cuisineType === c ? true : false} 
//                                                         onChange={(e)=>queryCuisineType(e,c)} />
//                                                 </div>
//                                                 <label className='block border-none cursor-pointer' 
//                                                     style={{color:sellerPrimaryColor1, fontSize: filterItemTextSize}} htmlFor={c}>{c}
//                                                 </label>
//                                             </div>
//                                         )
//                                     }
//                                     </div>
//                                     <div className='w-full flex justify-center items-center mt-0.5' >
//                                         <button onClick={resetCuisineTypeFilter} 
//                                             className='w-[50%] flex text-nowrap items-center justify-center m-0.5 text-center rounded-md text-[11px] p-0.5 text-white' 
//                                             style={{backgroundColor:sellerPrimaryColor1}}>
//                                             <MdFilterListOff size={12} className='mr-1' />Clear This Filter
//                                         </button>
//                                         <button onClick={resetFilter} 
//                                             className='w-[50%] flex text-nowrap items-center justify-center m-0.5 text-center rounded-md text-[11px] p-0.5 text-white' 
//                                             style={{backgroundColor:sellerPrimaryColor1}}>
//                                             <MdFilterListOff size={12} className='mr-1' />Clear All Filters
//                                         </button> 
//                                     </div>
//                                 </Collapsible>
//                             </div>
//                             <div className={` ${sellerBoolShowSiteHoliday  ? '' : 'hidden'} p-1 border rounded-md mb-2 `}
//                                 style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                                 <Collapsible 
//                                     trigger={triggerClosed("Holidays")} 
//                                     triggerWhenOpen={triggerOpen("Holidays")}
//                                     transitionTime={300}
//                                     easing="ease-in-out"
//                                     contentOuterClassName="overflow-hidden"
//                                     open={holidayURLParam !== undefined && typeof holidayURLParam === 'string' && holidayURLParam.length > 0}>
//                                     <div className='grid grid-cols-2 gap-0'>
//                                         {
//                                             arrHolidays.sort().map((c,i) =>
//                                                 <div key={i} className='ml-0.5 p-0.5 w-full border-none flex 
//                                                         justify-start items-center gap-1 py-1'>
//                                                     <div className='border-none align-top'>
//                                                         <input type="checkbox" id={c} className='border-none'
//                                                             style={{accentColor:sellerPrimaryColor1 , borderColor:sellerPrimaryColor1}}
//                                                             checked={holiday === c ? true : false} 
//                                                             onChange={(e)=>queryHoliday(e,c)} />
//                                                     </div>
//                                                     <label className='block border-none cursor-pointer' 
//                                                         style={{color:sellerPrimaryColor1, fontSize: filterItemTextSize}} htmlFor={c}>{c}
//                                                     </label>
//                                                 </div>
//                                             )
//                                         }
//                                     </div>
//                                     <div className='w-full flex justify-center items-center mt-0.5' >
//                                         <button onClick={resetHolidayFilter} 
//                                             className='w-[50%] flex text-nowrap items-center justify-center m-0.5 text-center rounded-md text-[11px] p-0.5 text-white' 
//                                             style={{backgroundColor:sellerPrimaryColor1}}>
//                                             <MdFilterListOff size={12} className='mr-1' />Clear This Filter
//                                         </button>
//                                         <button onClick={resetFilter} 
//                                             className='w-[50%] flex text-nowrap items-center justify-center m-0.5 text-center rounded-md text-[11px] p-0.5 text-white' 
//                                             style={{backgroundColor:sellerPrimaryColor1}}>
//                                             <MdFilterListOff size={12} className='mr-1' />Clear All Filters
//                                         </button> 
//                                     </div>
//                                 </Collapsible>
//                             </div>
//                             <div className=' '> 
//                                 <div className={` ${sellerBoolShowSitePayments ? '' : 'hidden'} p-1 border rounded-md mb-2`} 
//                                     style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                                     <Collapsible 
//                                         trigger={triggerClosed("Price Range")} 
//                                         triggerWhenOpen={triggerOpen("Price Range")}
//                                         transitionTime={300}
//                                         easing="ease-in-out"
//                                         contentOuterClassName="overflow-hidden"
//                                         open={false}>
//                                         <div className={`p-2 flex flex-col gap-0.5`}>
//                                             <Range
//                                                 step={intPriceRangeStep} 
//                                                 min={priceRange.low} //priceRange.low  priceRangeMinPrice
//                                                 max={priceRange.high}  //priceRange.high priceRangeMaxPrice 
//                                                 values={(state.values)}
//                                                 onChange={(values) => setState({values})}
//                                                 renderTrack={({props, children}) => (
//                                                     <div {...props} className='w-full h-[6px] bg-slate-500 rounded-full cursor-pointer'>
//                                                         {children}
//                                                     </div>
//                                                 )}
//                                                 renderThumb={({ props }) => (
//                                                     <div className='w-[15px] h-[15px] bg-[#059473] rounded-full' {...props}  />
//                                                 )} 
//                                             />  
//                                             <div>
//                                                 <span className='font-bold text-lg' style={{color:sellerPrimaryColor1}}>${Math.floor(state.values[0])} - ${Math.floor(state.values[1])}</span>            
//                                             </div>
//                                             <div className='w-full flex justify-center items-center mt-0.5' >
//                                                 <button onClick={resetPriceRangeFilter} 
//                                                     className='w-[50%] flex text-nowrap items-center justify-center m-0.5 text-center rounded-md text-[11px] p-0.5 text-white' 
//                                                     style={{backgroundColor:sellerPrimaryColor1}}>
//                                                     <MdFilterListOff size={12} className='mr-1' />Clear This Filter
//                                                 </button>
//                                                 <button onClick={resetFilter} 
//                                                     className='w-[50%] flex text-nowrap items-center justify-center m-0.5 text-center rounded-md text-[11px] p-0.5 text-white' 
//                                                     style={{backgroundColor:sellerPrimaryColor1}}>
//                                                     <MdFilterListOff size={12} className='mr-1' />Clear All Filters
//                                                 </button> 
//                                             </div>
//                                         </div>
//                                     </Collapsible>
//                                 </div>
//                                 <div className={` ${sellerBoolShowSiteRating ? '' : 'hidden'} p-1 border rounded-md mb-2`}
//                                     style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                                     <Collapsible 
//                                         trigger={triggerClosed("Rating")} 
//                                         triggerWhenOpen={triggerOpen("Rating")}
//                                         transitionTime={300}
//                                         easing="ease-in-out"
//                                         contentOuterClassName="overflow-hidden"
//                                         open={false}>
//                                         <div className={` py-3 flex flex-col gap-1 border-none`}>
//                                             <div className='flex flex-col gap-3'>
//                                                 <div onClick={() => setRating(5)} className='text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer'>
//                                                     <span><AiFillStar/> </span>
//                                                     <span><AiFillStar/> </span>
//                                                     <span><AiFillStar/> </span>
//                                                     <span><AiFillStar/> </span>
//                                                     <span><AiFillStar/> </span>
//                                                 </div>
//                                                 <div onClick={() => setRating(4)} className='text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer'>
//                                                     <span><AiFillStar/> </span>
//                                                     <span><AiFillStar/> </span>
//                                                     <span><AiFillStar/> </span>
//                                                     <span><AiFillStar/> </span>
//                                                     <span><CiStar/> </span>
//                                                 </div>
//                                                 <div onClick={() => setRating(3)} className='text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer'>
//                                                     <span><AiFillStar/> </span>
//                                                     <span><AiFillStar/> </span>
//                                                     <span><AiFillStar/> </span>
//                                                     <span><CiStar/> </span>
//                                                     <span><CiStar/> </span>
//                                                 </div>
//                                                 <div onClick={() => setRating(2)} className='text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer'>
//                                                     <span><AiFillStar/> </span>
//                                                     <span><AiFillStar/> </span>
//                                                     <span><CiStar/> </span>
//                                                     <span><CiStar/> </span>
//                                                     <span><CiStar/> </span>
//                                                 </div>
//                                                 <div onClick={() => setRating(1)} className='text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer'>
//                                                     <span><AiFillStar/> </span>
//                                                     <span><CiStar/> </span>
//                                                     <span><CiStar/> </span>
//                                                     <span><CiStar/> </span>
//                                                     <span><CiStar/> </span>
//                                                 </div>
//                                                 <div className='text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer'>
//                                                     <span><CiStar/> </span>
//                                                     <span><CiStar/> </span>
//                                                     <span><CiStar/> </span>
//                                                     <span><CiStar/> </span>
//                                                     <span><CiStar/> </span>
//                                                 </div>
//                                             </div> 
//                                         </div>
//                                         <div className='w-full flex justify-center items-center mt-0.5' >
//                                             <button onClick={resetRatingFilter} 
//                                                 className='w-[50%] flex text-nowrap items-center justify-center m-0.5 text-center rounded-md text-[11px] p-0.5 text-white' 
//                                                 style={{backgroundColor:sellerPrimaryColor1}}>
//                                                 <MdFilterListOff size={12} className='mr-1' />Clear This Filter
//                                             </button>
//                                             <button onClick={resetFilter} 
//                                                 className='w-[50%] flex text-nowrap items-center justify-center m-0.5 text-center rounded-md text-[11px] p-0.5 text-white' 
//                                                 style={{backgroundColor:sellerPrimaryColor1}}>
//                                                 <MdFilterListOff size={12} className='mr-1' />Clear All Filters
//                                             </button> 
//                                         </div>
//                                     </Collapsible>
//                                 </div>
                                
//                                 <button onClick={resetFilter} 
//                                     className='font-semibold flex  rounded-lg w-full py-1 px-4 text-white' style={{backgroundColor:sellerPrimaryColor1}}>
//                                     <MdFilterListOff className='mr-1 mt-0.5' /> Clear All Filters
//                                 </button> 
//                                 <button onClick={goToSampleMenus} 
//                                     className='mt-2 font-semibold flex rounded-lg w-full py-1 px-4 text-white' 
//                                     style={{backgroundColor:sellerPrimaryColor1}}>  
//                                     <MdOutlineRestaurantMenu className='mr-1 mt-1' /> Sample Menus    
//                                 </button>
//                                 <button onClick={goToSellerPackages} 
//                                     className='mt-2 font-semibold flex rounded-lg w-full py-1 px-4 text-white' 
//                                     style={{backgroundColor:sellerPrimaryColor1}}>  
//                                     <FaGift className='mr-1 mt-1' /> Packages   
//                                 </button>
//                                 <div className={` ${sellerBoolShowSiteProductsUnderFilter ? '' : 'hidden'} 
//                                     py-3 flex gap-4 md:hidden border-2 rounded-lg mt-2 justify-center items-center`}
//                                     style={{borderColor:sellerPrimaryColor1}}>
//                                     <Products title={'Latest '+ sellerProductPluralTerm} products={latest_product} parentPage={'Shops'} />
//                                 </div>
//                             </div>
//                         </div>
//                         <div className='w-9/12 md-lg:w-8/12 md:w-full'>
//                             <div className='pl-2 md:pl-0'>
//                                 <div className='py-1 px-2 mb-4 flex justify-between items-start border'
//                                     style={{borderColor:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                                     <div className='flex gap-1 justify-center items-start md-lg:hidden'>
//                                         <div className={`p-1 text-lg font-medium `} style={{color:sellerPrimaryColor1}}>
//                                             <span className=''>{totalProduct} {sellerProductTerm}</span>
//                                             <span className= {` ${totalProduct > 1 ? '': 'hidden'} `} >s</span>
//                                             <span className='ml-1 text-[14px] font-normal mb-0.5 border-none ' style={{color:sellerPrimaryColor1,borderColor:sellerPrimaryColor1}}>
//                                                 <span className={` ${category ? '' : 'hidden'} `}>Category: {category}; </span>
//                                                 <span className={` ${mainIngredient ? '' : 'hidden'} `}>{sellerMainIngredientTerm}: {mainIngredient}; </span>
//                                                 <span className={` ${FMP ? '' : 'hidden'} `}>FMP: {FMP}; </span>
//                                                 <span className={` ${cookingMethod ? '' : 'hidden'} `}>Cooking Method: {cookingMethod}; </span>
//                                                 <span className={` ${byThePan ? '' : 'hidden'} `}>By The Pan: {byThePan}; </span>
//                                                 <span className={` ${dietaryRestrictions ? '' : 'hidden'} `}>Dietary Restrictions: {dietaryRestrictions}; </span>
//                                                 <span className={` ${cuisineType ? '' : 'hidden'} `}>Cuisine: {cuisineType}; </span>
//                                                 <span className={` ${holiday ? '' : 'hidden'} `}>Holiday: {holiday}; </span>
//                                                 <span className={` ${rating ? '' : 'hidden'} `}>Rating: {rating} Star</span>
//                                             </span>
//                                         </div>
//                                     </div>

//                                     <div className='flex justify-center items-center gap-2 border-none border-black'>
//                                         <select onChange={(e)=>setSortPrice(e.target.value)} name="" id="" 
//                                             className={` ${sellerBoolShowSitePayments ? '' : 'hidden'} p-1 border outline-0 font-semibold`}
//                                             style={{color:sellerPrimaryColor1}}>
//                                             <option value="">Sort By</option>
//                                             <option className={` ${sellerBoolShowSitePayments ? '' : 'hidden'} `} value="low-to-high">Low to High Price</option>
//                                             <option className={` ${sellerBoolShowSitePayments ? '' : 'hidden'} `} value="high-to-low">High to Low Price </option>
//                                         </select>
//                                         <div className='flex mt-0.5 mb-0.5 gap-1 justify-center items-start md-lg:hidden'>
//                                             {/*  && 'bg-slate-300' */}
//                                             <div onClick={()=> setStyles('grid')} 
//                                                 className={`p-2 ${styles === 'grid'} 
//                                                 bg-slate-300 hover:bg-white cursor-pointer rounded-lg border`}
//                                                 style={{borderColor:sellerPrimaryColor1}}>
//                                                 <BsFillGridFill style={{color:sellerPrimaryColor1}} /> 
//                                             </div>
//                                             {/*  && 'bg-slate-300' */}
//                                             <div onClick={()=> setStyles('list')} 
//                                                 className={`p-2 ${styles === 'list'} 
//                                                 bg-white hover:bg-slate-300 cursor-pointer rounded-lg border`}
//                                                 style={{borderColor:sellerPrimaryColor1}}>
//                                                 <FaThList style={{color:sellerPrimaryColor1}} />
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className='pb-8'>
//                                     <ShopProductGridListView products={products} styles={styles} />  
//                                 </div>
//                                 <div>
//                                     {
//                                         totalProduct > parPage &&  
//                                             <Pagination pageNumber={pageNumber} setPageNumber={setPageNumber} 
//                                                 totalItems={totalProduct} parPage={parPage} 
//                                                 showItem={Math.floor(totalProduct / parPage )} />
//                                             //<Pagination pageNumber={pageNumber} setPageNumber={setPageNumber} totalItems={10} 
//                                             // parPage={parPage} showItem={Math.floor(10 / 3 )} />
//                                     }
//                                 </div>
//                             </div>
//                         </div>
//                     </div>    
//                 </div> 
//             </section>
//             <Footer/>
//         </div>
//     );
// };

// export default Shops;



